try {

  // Drawer controller. Everything visual is CSS keyed off one attribute —
  // `data-rail-drawer="open"` on <html> — so this only has to own state,
  // focus and the media-query boundary.
  (function () {
    var root = document.documentElement;
    var panel = document.getElementById('rail-drawer-panel');
    var toggle = document.getElementById('rail-drawer-toggle');
    var closeBtn = document.getElementById('rail-drawer-close');
    var scrim = document.getElementById('rail-drawer-scrim');
    if (!panel || !toggle) return;

    // Must match the `.page-rail` breakpoint in Base.astro exactly. Above it
    // the rail is a rail and none of this applies.
    var mq = window.matchMedia('(max-width: 1239.98px)');
    var restoreFocusTo = null;

    function isOpen() {
      return root.getAttribute('data-rail-drawer') === 'open';
    }

    // Every focusable in the panel, minus the honeypot (tabindex -1 already
    // excludes it) and minus anything on the step that isn't currently shown —
    // `offsetParent` is null for those, and for the panel's own contents when
    // the drawer is closed.
    function focusables() {
      var sel =
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])';
      return Array.prototype.filter.call(panel.querySelectorAll(sel), function (el) {
        return el.offsetParent !== null && el.tabIndex !== -1;
      });
    }

    // The panel's first real field — the property address on step 1, or
    // whatever step 2 leads with for someone re-opening a form they had
    // already advanced. Same selector as Base.astro's [data-offer-focus]
    // handler, deliberately: both routes into the form must land the visitor
    // in the same place. `tabindex="-1"` skips the honeypot (focusing it would
    // flag the seller's own submission as a bot's) and `offsetParent` skips
    // the step that isn't currently shown.
    function firstField() {
      var sel =
        'input:not([type="hidden"]):not([disabled]):not([tabindex="-1"]), select:not([disabled]), textarea:not([disabled])';
      return Array.prototype.filter.call(panel.querySelectorAll(sel), function (el) {
        return el.offsetParent !== null;
      })[0];
    }

    function open() {
      if (!mq.matches || isOpen()) return;
      restoreFocusTo = document.activeElement;
      root.setAttribute('data-rail-drawer', 'open');
      toggle.setAttribute('aria-expanded', 'true');
      // Promoted to a real dialog only while it is actually covering the page.
      // At ≥1240px the same element is a plain sticky card and must not claim
      // to be modal, which is why these are set here and cleared on close
      // rather than baked into the markup.
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-label', 'Request a cash offer');
      // Land on the ADDRESS, not the way out. `focusables()[0]` is the close
      // button — it is first in DOM order — so opening the drawer used to put
      // the focus ring around an X, which tells someone who just asked for an
      // offer that the notable thing in here is how to leave. The address
      // field is the ask; give it the ring, and on a phone the keyboard comes
      // up with it. Nothing is lost on the way out: the close button is still
      // the first stop in the panel's tab order, and Escape and the scrim
      // still close.
      var first = firstField() || focusables()[0];
      if (first) first.focus();
    }

    function close(returnFocus) {
      if (!isOpen()) return;
      // Blur first: leaving focus on a control inside a panel that is about to
      // become `visibility: hidden` strands it on an element the browser then
      // refuses to keep focused, and focus silently falls back to <body>.
      if (panel.contains(document.activeElement)) document.activeElement.blur();
      root.removeAttribute('data-rail-drawer');
      toggle.setAttribute('aria-expanded', 'false');
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      panel.removeAttribute('aria-label');
      if (returnFocus !== false) {
        var target = restoreFocusTo && restoreFocusTo.isConnected ? restoreFocusTo : toggle;
        // Never hand focus back to something inside the panel we just hid.
        if (panel.contains(target)) target = toggle;
        target.focus();
      }
      restoreFocusTo = null;
    }

    toggle.addEventListener('click', function () {
      if (isOpen()) close();
      else open();
    });
    if (closeBtn) closeBtn.addEventListener('click', function () { close(); });
    if (scrim) scrim.addEventListener('click', function () { close(); });

    document.addEventListener('keydown', function (e) {
      // `mq.matches` and not just `isOpen()`: the attribute is the open state,
      // but it is only MEANINGFUL below the breakpoint. Above it the drawer CSS
      // is switched off, so an attribute left behind by a crossing we never
      // heard about would be invisible — and this handler would still be live,
      // silently trapping Tab inside the rail card and swallowing Escape on a
      // desktop page. Checking the width here means the worst a missed
      // crossing can do is leave three stale ARIA attributes, not break
      // keyboard navigation for the whole page.
      if (!mq.matches || !isOpen()) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      // Focus trap. The panel is aria-modal while open, so the tab strip and
      // the page behind it are out of reach by design — the close button and
      // Escape are the ways out.
      var list = focusables();
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      } else if (!panel.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      }
    });

    // Crossing back up to the rail layout has to clear the whole open state,
    // not just the transform: a leftover `data-rail-drawer` would keep the body
    // scroll-locked and leave a sticky rail card announcing itself as a modal
    // dialog. `returnFocus` is false because the tab that would receive it is
    // display:none up there.
    var onChange = function () {
      if (!mq.matches) close(false);
    };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
    // Belt and braces on the same cleanup. `change` is the right event and
    // fires on its own in a real browser, but it is a single point of failure
    // for a state that outlives the layout it belongs to, and `close()` returns
    // immediately unless the drawer is actually open — so a resize listener
    // costs an attribute read per frame of a drag and removes the dependency.
    window.addEventListener('resize', onChange);

    // Every in-page route to the form has to become "open the drawer" once the
    // form is off-canvas — a fragment jump to a `position: fixed` element does
    // nothing at all, so without this the header CTA and the footer's offer
    // link are dead below 1240px. Base.astro's [data-offer-focus] handler
    // checks for this object and stands down when it takes the click.
    window.__railDrawer = {
      isActive: function () { return mq.matches; },
      isOpen: isOpen,
      open: open,
      close: close,
    };

    // The footer's offer link is a plain `#offer` anchor on builds with no call
    // room (with one, it points at the room and must be left alone), and it
    // carries no [data-offer-focus], so it needs catching here.
    document.addEventListener('click', function (e) {
      if (!mq.matches) return;
      var a = e.target && e.target.closest && e.target.closest('a[href$="#offer"]');
      if (!a || a.hasAttribute('data-offer-focus')) return;
      e.preventDefault();
      open();
    });
  })();

} catch (e) {
  setTimeout(function () { throw e; });
}
try {
(function(){const geoapifyKey = null;
const googlePlacesKey = null;
const addressProviderSplit = null;
const turnstileSiteKey = null;
const fallbackIdentity = {"brand":"testing"};
const callConsentChannels = ["call"];
const smsConsentChannels = ["sms"];
const clearDraftOnSubmit = false;

    const identity = (function () {
      var raw = document.currentScript && document.currentScript.getAttribute('data-identity');
      try {
        if (raw) return JSON.parse(raw);
      } catch (_) {}
      console.error('[lead-form] no readable data-identity on its script tag; sending the brand alone');
      return fallbackIdentity;
    })();
  (function () {
    var form = document.getElementById('lead-form');
    var success = document.getElementById('lead-success');
    if (!form || !success) return;

    // Stamp the form-load time. The server uses this to detect bots that
    // fill the form faster than humanly possible (< 2 seconds).
    var tsField = document.getElementById('lf-ts-start');
    if (tsField) tsField.value = String(Date.now());

    // Address autocomplete — ONE listbox, EITHER of two providers. No
    // third-party script loads for either: both are plain REST calls from this
    // page, so there is no Maps-SDK payload to defer and nothing to keep off
    // the critical path.
    var addressEl = document.getElementById('lf-address');
    var acList = null; // the <ul role="listbox"> we own
    var acItems = []; // normalized suggestion objects currently rendered
    var acActive = -1; // highlighted option index, -1 = none
    var acSeq = 0; // request sequence — drops out-of-order responses
    var acDebounce = null;
    // Tracks whether the address_entered micro-conversion has fired, so the
    // two-step "Continue" can fire it for manually-typed addresses (picking a
    // suggestion fires it via commitAddress) without double-counting.
    var addressFired = false;
    // Same guard for the contact_step funnel event: Back → Continue re-runs
    // goToStep2, so without this flag the step event would double-fire.
    var contactFired = false;

    // ── Address suggestions: our own listbox, either provider ───────────────
    //
    // Structurally this is the shape the legacy `google.maps.places.Autocomplete`
    // widget was replaced with, and it is what makes swapping the provider
    // underneath possible at all: our own listbox driven against the EXISTING
    // <input>, never a drop-in widget. A widget owning its own input inside a
    // shadow root would cost three things this form is built on:
    //   * the `property_address` FormData entry and its `required` validation
    //     (submitLead + the edge contract both read that name);
    //   * the ability to read a MANUALLY TYPED address — goToStep2 accepts one
    //     and refineTzFromAddress parses the state out of the raw string, so a
    //     seller who ignores the dropdown must still be able to continue;
    //   * the label/focus/Enter wiring the two-step flow already depends on.
    //
    // Everything provider-specific is confined to the two adapter objects
    // below. Each exposes the same pair:
    //   search(q)      → Promise<normalized[]>   — what to show
    //   resolve(pred)  → Promise<{full, stateCode}> — what to commit
    // Nothing downstream of `commitAddress` knows which one ran.
    var AC_MAX_ITEMS = 5;
    // Shared by both providers on purpose — see onAddressInput.
    var AC_DEBOUNCE_MS = 250;
    // Trailing country, which both providers append and a US-only form never
    // wants to show or store.
    var AC_COUNTRY_TAIL = /,\s*(United States of America|United States|USA)\s*$/i;

    function acText(v) {
      return v == null ? '' : String(v);
    }

    function stripCountry(s) {
      return acText(s).replace(AC_COUNTRY_TAIL, '').trim();
    }

    // ── Which provider serves this visit ────────────────────────────────────
    //
    // Two are wired because the only honest way to choose between them is to
    // run both against real sellers. Geoapify is free (3k requests/day, no card)
    // but is a flat gazetteer; Google matches partial and misspelled addresses
    // better and costs both money and a billing relationship. Which of those
    // trades is worth it is a question about THIS form's sellers, so the answer
    // comes from the telemetry below rather than from either vendor's demo.
    //
    // A brand can carry either key or both. With both, `addressProviderSplit` is
    // the percentage of visits Google serves — 0 means Geoapify keeps every
    // visit while a Google key sits ready, 100 is a full cutover, and anything
    // between runs the comparison.
    //
    // The draw is STICKY FOR THE TAB. Re-drawing per keystroke (or even per
    // page view) would mix two providers into one seller's typing, which
    // measures neither and would visibly change the dropdown mid-address.
    // sessionStorage is the same per-tab scope the funnel beacon's
    // `imp_session` key uses, so a visit's provider and its telemetry row agree
    // by construction.
    var AC_PROVIDER_KEY = 'addr_ac_provider';
    // What "both keys, no split saved" means. An operator who has just pasted a
    // second key is asking for a comparison, not a silent cutover in either
    // direction, so an unset split runs an even one. The card writes an explicit
    // value the moment it is touched.
    var AC_DEFAULT_GOOGLE_PERCENT = 50;

    function acGooglePercent() {
      var n = parseInt(addressProviderSplit, 10);
      if (isNaN(n)) return AC_DEFAULT_GOOGLE_PERCENT;
      return Math.max(0, Math.min(100, n));
    }

    function acPickProvider() {
      var hasGeoapify = !!geoapifyKey;
      var hasGoogle = !!googlePlacesKey;
      if (!hasGeoapify && !hasGoogle) return null;
      // One key configured is not an experiment, and there is no draw to
      // remember — the split is ignored entirely rather than being able to
      // switch off the only provider a brand actually has.
      if (!hasGoogle) return 'geoapify';
      if (!hasGeoapify) return 'google';
      try {
        var saved = sessionStorage.getItem(AC_PROVIDER_KEY);
        if (saved === 'google' || saved === 'geoapify') return saved;
      } catch (_) {}
      var pick = Math.random() * 100 < acGooglePercent() ? 'google' : 'geoapify';
      try {
        sessionStorage.setItem(AC_PROVIDER_KEY, pick);
      } catch (_) {
        // Storage blocked. The draw stands for this page load; a reload may
        // land on the other side, which costs comparability on ONE visit and is
        // strictly better than turning suggestions off.
      }
      return pick;
    }

    // ── Telemetry: what the provider actually did ───────────────────────────
    //
    // The question this answers is not which provider we like, it is which one
    // gets sellers to a committed address — so what is counted is the seller's
    // behavior (did they take a suggestion, how long did it take, did they give
    // up and type it themselves) alongside the mechanical facts that explain it
    // (latency, empty responses, errors).
    //
    // Counted here and flushed ONCE per visit alongside the funnel beacon
    // (Base.astro ▸ bankFlush → /api/landing-event), so measuring a provider
    // costs no extra requests and no extra endpoint. Nothing on it identifies
    // the visitor: a provider name, counts, and milliseconds. In particular the
    // typed text is NEVER sent — the query is the one field on this page most
    // likely to BE the seller's home address.
    function acNewStats(provider) {
      return {
        provider: provider,
        requests: 0, // HTTP calls made (both legs, on Google)
        errors: 0, // calls that threw or came back non-OK
        empty: 0, // calls that returned zero usable suggestions
        suggestions: 0, // options rendered across all responses
        keystrokes: 0, // input events on the address field
        picked: false, // a suggestion was committed
        picked_index: null, // 0-based rank of the first one taken
        manual: false, // Continue clicked on a hand-typed address instead
        first_paint_ms: null, // first keystroke → first list painted
        time_to_commit_ms: null, // first keystroke → address committed
        latency_total_ms: 0,
        latency_max_ms: 0,
      };
    }
    var acStats = acNewStats(null);
    var acFirstKeyAt = 0;
    // A LIVE reference, read by Base.astro's flush — so the last flush of a
    // visit carries the final state rather than a snapshot taken early.
    window.__acStats = acStats;

    function acSinceFirstKey() {
      return acFirstKeyAt ? Date.now() - acFirstKeyAt : null;
    }

    // Every provider call goes through here, so `requests`, `errors` and the
    // latency totals mean exactly the same thing on both sides of the split.
    // Comparing numbers that were counted differently is worse than not
    // measuring at all, because it looks like an answer.
    //
    // The counters are captured when the call STARTS, so a request is always
    // booked to the provider that made it — even one still in flight when a
    // failover (acFailOver) moves the page onto the other provider.
    function acTimed(fn) {
      var stats = acStats;
      var startedAt = Date.now();
      stats.requests++;
      return fn().then(
        function (v) {
          stats.latency_total_ms += Date.now() - startedAt;
          stats.latency_max_ms = Math.max(
            stats.latency_max_ms,
            Date.now() - startedAt
          );
          return v;
        },
        function (e) {
          stats.latency_total_ms += Date.now() - startedAt;
          stats.latency_max_ms = Math.max(
            stats.latency_max_ms,
            Date.now() - startedAt
          );
          stats.errors++;
          throw e;
        }
      );
    }

    // A non-OK HTTP answer, carrying its status so acFailOver can tell a
    // provider that REFUSED this page (4xx) from one that merely hiccuped.
    function acHttpError(label, status) {
      var err = new Error(label + ' ' + status);
      err.status = status;
      return err;
    }

    // ── Provider: Geoapify ──────────────────────────────────────────────────
    //
    // Picked when the legacy Places widget died, because enabling any Maps
    // Platform API requires a billing account with a card on file even to stay
    // inside the free tier; Geoapify's free plan (3k requests/day, commercial
    // use allowed) needs no billing relationship at all.
    //
    // One request per debounced keystroke, and the response already carries the
    // full structured address INCLUDING `state_code` — so there is no details
    // round-trip and no session token. That also means every keystroke bills.
    var GEOAPIFY_ENDPOINT = 'https://api.geoapify.com/v1/geocode/autocomplete';
    // Geoapify's server-side `type` param can only narrow to street level (its
    // values are country/state/city/postcode/street/amenity/locality — there is
    // no house-number tier), so asking it to filter would DROP the building-level
    // hits that are the whole point of a property-address field. Instead we
    // overfetch the raw list and rank it ourselves off the `result_type` Geoapify
    // stamps on every result — the one address-precision signal it exposes that
    // its request params cannot act on.
    //
    // This is the deliberate INVERSE of the Google path below. Geoapify returns a
    // single relevance-sorted list that interleaves buildings, streets, POIs and
    // localities, so a house-number result can sit below a bare street or a
    // business; left alone, the dropdown buries the thing the seller is trying to
    // pick. Google ranks full addresses above streets server-side and needs no
    // such help, so it gets locale hints and no post-processing. Each provider is
    // met where its own ranking leaves off — not made to behave the same.
    var GEOAPIFY_TIER = { building: 0, street: 1 }; // lower = nearer the top
    // Overfetch so the client-side tiering has a real list to reorder and thin
    // down to AC_MAX_ITEMS without going empty.
    var GEOAPIFY_FETCH_LIMIT = 10;

    var geoapifyProvider = {
      id: 'geoapify',
      search: function (q) {
        var url =
          GEOAPIFY_ENDPOINT +
          '?text=' + encodeURIComponent(q) +
          // `filter` HARD-limits to the US (bias would only rank it up), which
          // matches the form's US-only TCPA + timezone cascade.
          '&filter=countrycode:us' +
          '&limit=' + GEOAPIFY_FETCH_LIMIT +
          '&format=json' +
          '&lang=en' +
          '&apiKey=' + encodeURIComponent(geoapifyKey);
        return acTimed(function () {
          return fetch(url, { method: 'GET', mode: 'cors', credentials: 'omit' })
            .then(function (r) {
              if (!r.ok) throw acHttpError('geoapify', r.status);
              return r.json();
            });
        }).then(function (body) {
          var results = (body && body.results) || [];
          var preds = [];
          for (var i = 0; i < results.length; i++) {
            var norm = normalizeGeoapify(results[i]);
            if (norm) preds.push(norm);
          }
          // Keep only address-shaped tiers (building, then street) and float the
          // more precise tier up. A STABLE sort preserves Geoapify's own
          // relevance order WITHIN a tier — so among buildings the API's ranking
          // still wins; the tier only decides that any building outranks any bare
          // street. Everything coarser (POIs, cities, postcodes) is dropped.
          var addressish = preds
            .filter(function (p) {
              return GEOAPIFY_TIER[p.resultType] !== undefined;
            })
            .map(function (p, idx) {
              return { p: p, tier: GEOAPIFY_TIER[p.resultType], idx: idx };
            })
            .sort(function (a, b) {
              return a.tier - b.tier || a.idx - b.idx;
            })
            .map(function (e) {
              return e.p;
            });
          // If nothing address-shaped matched (a query that only hit a city or a
          // business), fall back to the raw ranked list — a loose dropdown beats
          // an empty one.
          return addressish.length ? addressish : preds;
        });
      },
      // Nothing to resolve: the suggestion already carried the formatted
      // address AND the state code, so a pick commits synchronously.
      resolve: function (pred) {
        return Promise.resolve({ full: pred.full, stateCode: pred.stateCode });
      },
    };

    // Geoapify result → the shape the listbox and commitAddress consume.
    // `address_line1` is the street line and `address_line2` the locality tail,
    // which map cleanly onto the two-line option this listbox renders.
    function normalizeGeoapify(r) {
      var line1 = acText(r.address_line1);
      var line2 = stripCountry(r.address_line2);
      var full = stripCountry(r.formatted);
      if (!full) full = [line1, line2].filter(Boolean).join(', ');
      if (!full) return null;
      return {
        full: full,
        main: line1 || full,
        secondary: line1 ? line2 : '',
        stateCode: acText(r.state_code).toUpperCase(),
        resultType: acText(r.result_type),
      };
    }

    // ── Provider: Google Places API (New) ───────────────────────────────────
    //
    // The `places:autocomplete` REST endpoint, NOT the legacy
    // `google.maps.places.Autocomplete` JS widget. That binding stopped working
    // for any Cloud project created on/after 2025-03-01
    // (LegacyApiNotActivatedMapError) and no amount of enabling brings it back;
    // this is the replacement API, called directly so it stays a fetch like the
    // other provider rather than a second SDK on the page.
    //
    // TWO calls per committed address, which is the shape Google's pricing
    // assumes: every autocomplete request in one SESSION, plus the Place
    // Details that closes it, bill as a single session so long as they share a
    // `sessionToken`. Minting a fresh token per keystroke — or reusing one
    // across selections — silently converts that into per-request billing, so
    // the token is minted once per typing arc and dropped the moment Details
    // runs. This is the structural difference from Geoapify worth remembering
    // when reading the comparison: `requests` counts HTTP calls on both sides,
    // but only Geoapify bills per call.
    var GOOGLE_AUTOCOMPLETE_URL =
      'https://places.googleapis.com/v1/places:autocomplete';
    var GOOGLE_DETAILS_BASE = 'https://places.googleapis.com/v1/places/';
    var googleSessionToken = null;
    // Address-shaped PRIMARY types, filtered server-side — the opposite of the
    // Geoapify path above, and deliberately so. Autocomplete (New) returns at
    // most FIVE predictions with no way to ask for more, which is also exactly
    // AC_MAX_ITEMS, so there is nothing to trim: filtering Google's answer here
    // in the browser could only ever shrink the dropdown below five, because
    // every business that took a slot is a slot Google will not refill. Geoapify
    // can afford its client-side filter only because it overfetches 10 first.
    //
    // Nor do we REORDER Google's answer the way we tier Geoapify's: Google
    // returns the five already relevance-ranked, full addresses above bare
    // streets, so the best implementation here is to trust that sort and touch
    // it as little as possible. The client-side work is Geoapify's because
    // Geoapify's ranking is the one that needs it.
    //
    // These are Table B values. `includedPrimaryTypes` on Autocomplete (New) is
    // the single request field allowed to carry Table B at all, so this filter
    // has no equivalent anywhere else in the call.
    //
    // NOT `['address']`. That was the legacy Place Autocomplete type COLLECTION
    // and the New API has no such value — it answers 400 "Invalid
    // included_primary_types", which is a hard failure of every request, not a
    // narrower result set. Keep in lockstep with `@address_types` in
    // google_places_verify_controller.ex; that probe is the canary for this list
    // going stale, since a type Google stops stamping as primary costs
    // suggestions silently rather than erroring.
    var GOOGLE_ADDRESS_TYPES = [
      'street_address',
      'premise',
      'subpremise',
      'route',
    ];

    function acUuid() {
      try {
        if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
      } catch (_) {}
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });
    }

    function googleToken() {
      if (!googleSessionToken) googleSessionToken = acUuid();
      return googleSessionToken;
    }

    var googleProvider = {
      id: 'google',
      search: function (q) {
        return acTimed(function () {
          return fetch(GOOGLE_AUTOCOMPLETE_URL, {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            headers: {
              'Content-Type': 'application/json',
              'X-Goog-Api-Key': googlePlacesKey,
            },
            body: JSON.stringify({
              input: q,
              includedPrimaryTypes: GOOGLE_ADDRESS_TYPES,
              // Hard US limit, matching Geoapify's countrycode filter and the
              // form's US-only TCPA + timezone cascade.
              includedRegionCodes: ['us'],
              // regionCode BIASES ranking and FORMATS the prediction text for the
              // US; includedRegionCodes above RESTRICTS the set. Complementary,
              // not redundant — the restriction bounds WHICH places, the region
              // code shapes how the survivors are ordered and written. With it,
              // Google's own relevance sort does the building-over-street work
              // that Geoapify needs a client-side pass for.
              regionCode: 'us',
              // Match the form's English UI and Geoapify's lang=en, so the two
              // providers' suggestion text is drawn in the same language and the
              // A/B compares like with like.
              languageCode: 'en',
              sessionToken: googleToken(),
            }),
          }).then(function (r) {
            if (!r.ok) throw acHttpError('places', r.status);
            return r.json();
          });
        }).then(function (body) {
          var suggestions = (body && body.suggestions) || [];
          var preds = [];
          for (var i = 0; i < suggestions.length; i++) {
            var norm = normalizeGooglePrediction(suggestions[i]);
            if (norm) preds.push(norm);
          }
          return preds;
        });
      },
      // Autocomplete (New) returns TEXT, never address components, so the state
      // code the timezone cascade wants needs a second call. It is also the call
      // that closes the billing session.
      resolve: function (pred) {
        if (!pred.placeId) {
          // No Details call to make, but the session still ends here — carrying
          // this token into the next typing arc is what turns session billing
          // back into per-request billing.
          googleSessionToken = null;
          return Promise.resolve({ full: pred.full, stateCode: '' });
        }
        var url =
          GOOGLE_DETAILS_BASE +
          encodeURIComponent(pred.placeId) +
          '?sessionToken=' +
          encodeURIComponent(googleToken());
        return acTimed(function () {
          return fetch(url, {
            method: 'GET',
            mode: 'cors',
            credentials: 'omit',
            headers: {
              'X-Goog-Api-Key': googlePlacesKey,
              'X-Goog-FieldMask': 'formattedAddress,addressComponents',
            },
          }).then(function (r) {
            if (!r.ok) throw acHttpError('places details', r.status);
            return r.json();
          });
        }).then(
          function (place) {
            // Spent either way: the next typing arc must mint a new token, or
            // Google bills the requests that follow individually.
            googleSessionToken = null;
            return {
              full: stripCountry(place && place.formattedAddress) || pred.full,
              stateCode: googleStateCode(place),
            };
          },
          function (e) {
            googleSessionToken = null;
            throw e;
          }
        );
      },
    };

    // Places (New) prediction → the same normalized shape Geoapify produces.
    // `stateCode` is deliberately empty here: it does not exist until Details
    // runs, and inventing one from the text would defeat the cascade's own
    // fallback (see commitAddress — it wants null, not a guess).
    function normalizeGooglePrediction(s) {
      var p = s && s.placePrediction;
      if (!p) return null;
      var fmt = p.structuredFormat || {};
      var main = acText(fmt.mainText && fmt.mainText.text);
      var secondary = stripCountry(fmt.secondaryText && fmt.secondaryText.text);
      var full = stripCountry(p.text && p.text.text);
      if (!full) full = [main, secondary].filter(Boolean).join(', ');
      if (!full) return null;
      return {
        full: full,
        main: main || full,
        secondary: main ? secondary : '',
        stateCode: '',
        resultType: 'building',
        placeId: acText(p.placeId),
      };
    }

    function googleStateCode(place) {
      var comps = (place && place.addressComponents) || [];
      for (var i = 0; i < comps.length; i++) {
        var types = (comps[i] && comps[i].types) || [];
        if (types.indexOf('administrative_area_level_1') !== -1) {
          return acText(comps[i].shortText).toUpperCase();
        }
      }
      return '';
    }

    // ── The chosen provider ─────────────────────────────────────────────────
    var acProviderId = acPickProvider();
    var acProvider =
      acProviderId === 'google'
        ? googleProvider
        : acProviderId === 'geoapify'
          ? geoapifyProvider
          : null;
    acStats.provider = acProviderId;

    // ── Failover: a provider that refuses the page hands it to the other ────
    //
    // The draw above assumes both keys WORK. When one does not (billing lapsed
    // on the Google project, the API got disabled, a key restriction stopped
    // matching the domain, Geoapify's daily cap ran out) every visit drawn to
    // it got a silent 4xx per keystroke and no suggestions at all, while the
    // other key sat unused. On 2026-09-19 that was 90% of FBF's visits: the
    // split sent them to a Google key answering 403 on every call.
    //
    // So a 4xx from the drawn provider, when the brand carries the other key,
    // moves the page to the other provider and retries the same keystroke. The
    // switch is written to the same sessionStorage key as the draw, so the rest
    // of the tab stays on the provider that works instead of paying one refused
    // call per page. 5xx and network failures do NOT fail over: those are
    // transient, and the next keystroke retries the same provider as before.
    //
    // Telemetry keeps the refusal visible rather than papering over it. The
    // page's stats row stays on the arm that was drawn, carrying the request
    // that failed, and counting after the switch goes to a detached object the
    // flush never reads. Booking the rescued visit to the other arm would give
    // it a first keystroke it never saw; booking it to the failed arm would
    // credit that arm with suggestions it never served. Later pages of the tab
    // start on the new provider from their first keystroke, so those count as
    // that provider cleanly. On Leads ▸ Funnel a broken key therefore shows as
    // an arm with a 100% error rate, not as an arm that quietly stopped
    // getting visits.
    //
    // Once per page: if the other provider refuses too, the field is a plain
    // text input (a fully supported path), not a loop between two dead keys.
    var acFailedOver = false;

    function acOtherProvider() {
      if (acProvider === googleProvider && geoapifyKey) return geoapifyProvider;
      if (acProvider === geoapifyProvider && googlePlacesKey) return googleProvider;
      return null;
    }

    function acFailOver(e) {
      if (acFailedOver) return false;
      var status = e && e.status;
      if (!(status >= 400 && status < 500)) return false;
      var other = acOtherProvider();
      if (!other) return false;
      acFailedOver = true;
      console.warn(
        '[lead] autocomplete: ' + acProvider.id + ' refused (' + status +
          '), switching to ' + other.id
      );
      acProvider = other;
      acProviderId = other.id;
      try {
        sessionStorage.setItem(AC_PROVIDER_KEY, other.id);
      } catch (_) {}
      acStats = acNewStats(other.id);
      return true;
    }

    // No script to wait on for either provider, so the combobox is live from the
    // first keystroke — the old Places WIDGET could only do this once the Maps
    // SDK had landed. A brand with no key at all never gets here and keeps
    // native browser autofill.
    if (addressEl && acProvider) initAddressCombobox();

    function initAddressCombobox() {
      var host = addressEl.parentNode;
      if (!host || acList) return;
      acList = document.createElement('ul');
      acList.id = 'lf-address-list';
      acList.className = 'lf-ac-list';
      acList.setAttribute('role', 'listbox');
      acList.setAttribute('aria-label', 'Address suggestions');
      acList.hidden = true;
      host.appendChild(acList);

      addressEl.setAttribute('role', 'combobox');
      addressEl.setAttribute('aria-autocomplete', 'list');
      addressEl.setAttribute('aria-controls', 'lf-address-list');
      addressEl.setAttribute('aria-expanded', 'false');
      // The browser's own autofill overlay would sit on top of our listbox, so
      // it goes off the moment we take over. The markup ships with native
      // street-address autofill ON, which is what a brand carrying NEITHER
      // provider key keeps — this function never runs for it.
      addressEl.setAttribute('autocomplete', 'off');

      addressEl.addEventListener('input', onAddressInput);
      // Close on blur, but late enough that a click on an option still lands.
      addressEl.addEventListener('blur', function () {
        setTimeout(closeAcList, 150);
      });
      // mousedown, not click: it fires before the input's blur, so the option
      // is still in the DOM when we read it.
      acList.addEventListener('mousedown', function (e) {
        var li = e.target && e.target.closest && e.target.closest('li[data-idx]');
        if (!li) return;
        e.preventDefault();
        chooseSuggestion(parseInt(li.getAttribute('data-idx'), 10));
      });
    }

    function onAddressInput() {
      if (acDebounce) clearTimeout(acDebounce);
      acStats.keystrokes++;
      if (!acFirstKeyAt) acFirstKeyAt = Date.now();
      var q = ((addressEl && addressEl.value) || '').trim();
      // Under 3 characters every prediction is noise, and each request costs
      // quota on both providers.
      if (q.length < 3) {
        closeAcList();
        return;
      }
      // 250ms, up from the 180ms the old Places WIDGET used, and deliberately
      // the SAME on both providers. Geoapify bills per request against a
      // 3k/day cap, so the debounce is what keeps one address from costing a
      // dozen of them; Google bundles a whole typing arc into one billable
      // session and could afford to be quicker — but two providers running at
      // two different debounces would make the latency numbers below
      // incomparable, which is most of what they are collected for.
      acDebounce = setTimeout(function () {
        requestSuggestions(q);
      }, AC_DEBOUNCE_MS);
    }

    function requestSuggestions(q) {
      if (!acProvider) return;
      var seq = ++acSeq;
      acProvider
        .search(q)
        .then(function (preds) {
          if (seq !== acSeq) return; // a newer keystroke already won
          if (!preds.length) acStats.empty++;
          renderSuggestions(preds);
        })
        .catch(function (e) {
          if (seq !== acSeq) return;
          console.warn('[lead] autocomplete request failed', e);
          // A refusal hands the page to the other provider, and this same
          // keystroke is asked again there so the seller never sees the gap.
          if (acFailOver(e)) {
            requestSuggestions(q);
            return;
          }
          // Degrades to a plain text field: typing an address by hand is a
          // fully supported path (goToStep2 parses a state out of the string).
          closeAcList();
        });
    }

    // `preds` is already normalized and address-filtered by the provider — all
    // that is left is the cross-provider tidying: drop repeats (Geoapify can
    // return the same address twice across datasources) and cap the list.
    function renderSuggestions(preds) {
      var deduped = [];
      var seen = {};
      for (var i = 0; i < preds.length; i++) {
        var norm = preds[i];
        if (!norm || seen[norm.full]) continue;
        seen[norm.full] = 1;
        deduped.push(norm);
      }
      preds = deduped.slice(0, AC_MAX_ITEMS);
      acStats.suggestions += preds.length;
      if (preds.length && acStats.first_paint_ms === null) {
        acStats.first_paint_ms = acSinceFirstKey();
      }

      acItems = preds;
      acActive = -1;
      acList.textContent = '';
      if (!preds.length) {
        closeAcList();
        return;
      }
      for (var k = 0; k < preds.length; k++) {
        var li = document.createElement('li');
        li.id = 'lf-ac-opt-' + k;
        li.className = 'lf-ac-item';
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        li.setAttribute('data-idx', String(k));
        var main = document.createElement('span');
        main.className = 'lf-ac-main';
        main.textContent = preds[k].main;
        li.appendChild(main);
        if (preds[k].secondary) {
          var secEl = document.createElement('span');
          secEl.className = 'lf-ac-sec';
          secEl.textContent = preds[k].secondary;
          li.appendChild(secEl);
        }
        acList.appendChild(li);
      }
      acList.hidden = false;
      addressEl.setAttribute('aria-expanded', 'true');
    }

    function setAcActive(idx) {
      var n = acItems.length;
      if (!n) return;
      // Wrap around in both directions.
      acActive = ((idx % n) + n) % n;
      for (var i = 0; i < acList.children.length; i++) {
        var li = acList.children[i];
        var on = i === acActive;
        li.classList.toggle('is-active', on);
        li.setAttribute('aria-selected', on ? 'true' : 'false');
      }
      var active = acList.children[acActive];
      if (active) {
        addressEl.setAttribute('aria-activedescendant', active.id);
        if (active.scrollIntoView) active.scrollIntoView({ block: 'nearest' });
      }
    }

    function closeAcList() {
      if (!acList) return;
      acList.hidden = true;
      acList.textContent = '';
      acItems = [];
      acActive = -1;
      addressEl.setAttribute('aria-expanded', 'false');
      addressEl.removeAttribute('aria-activedescendant');
    }

    // Returns true when the combobox consumed the key, so the caller's own
    // Enter → step 2 handling stands down for that press.
    function acKeydown(e) {
      if (!acList || acList.hidden || !acItems.length) return false;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setAcActive(acActive + 1);
        return true;
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        setAcActive(acActive <= 0 ? acItems.length - 1 : acActive - 1);
        return true;
      }
      if (e.key === 'Escape') {
        closeAcList();
        return true;
      }
      if (e.key === 'Enter' && acActive >= 0) {
        e.preventDefault();
        chooseSuggestion(acActive);
        return true;
      }
      return false;
    }

    function chooseSuggestion(idx) {
      var pred = acItems[idx];
      if (!pred) return;
      closeAcList();
      acStats.picked = true;
      if (acStats.picked_index === null) acStats.picked_index = idx;
      // Any in-flight search is now stale — the seller has chosen, and a
      // late response repainting the list under them would be worse than
      // useless.
      acSeq++;
      // Paint the choice IMMEDIATELY, before resolving it. Geoapify resolves
      // synchronously, but Google needs a Place Details round-trip for the
      // state code, and a field that sits on the half-typed string for another
      // couple hundred milliseconds after a tap reads as a dropped tap.
      if (pred.full) addressEl.value = pred.full;
      acProvider
        .resolve(pred)
        .then(function (resolved) {
          commitAddress(resolved.full || pred.full, resolved.stateCode);
        })
        .catch(function (e) {
          // The prediction text IS a full address, so a failed details call
          // costs only the structured state code — and refineTzFromAddress
          // parses one out of the string when it gets none.
          console.warn('[lead] autocomplete resolve failed', e);
          commitAddress(pred.full, '');
        });
    }

    // Everything that used to hang off the legacy widget's `place_changed`.
    // `stateCode` is the two-letter code when the provider gave us one, else "".
    function commitAddress(formatted, stateCode) {
      if (formatted) addressEl.value = formatted;
      if (acStats.time_to_commit_ms === null) {
        acStats.time_to_commit_ms = acSinceFirstKey();
      }
      // PRIMARY micro-conversion: committing a real address is a strong intent
      // signal in motivated-seller. See ladder doc in
      // src/layouts/Base.astro → setupMicroConversions().
      if (window.__fireConversion) {
        // value omitted — inherits leadValueMap['address_entered'] from
        // conversion-config.json (the authoritative source) in Base.astro.
        window.__fireConversion('address_entered', { currency: 'USD' });
      }
      addressFired = true;
      // Timezone cascade (b): use the structured state code rather than
      // re-parsing the formatted string. Geoapify returns it inline as
      // `state_code`; Google's comes from the Place Details
      // administrative_area_level_1 component's shortText. Falls back to string
      // parsing inside refineTzFromAddress when it's absent — pass null, not
      // "", so the fallback actually triggers.
      if (window.__refineTzFromAddress) {
        window.__refineTzFromAddress(stateCode || null);
      }
    }

    // ── Invisible Cloudflare Turnstile ──────────────────────────────────────
    // When the brand carries a public site key, load the Turnstile script on the
    // FIRST form interaction (never statically — consistent with the
    // zero-3P-until-interaction gate the tracking loader uses) and render an
    // invisible widget into #lf-turnstile. The token is read at submit via
    // turnstile.getResponse and posted as cf_turnstile_token. Fully best-effort:
    // any failure (script blocked, render throws, no token yet) leaves the token
    // empty and the form still submits — an absent/unverified token is ignored by
    // the edge when TURNSTILE_SECRET is unset, so this is safe to ship first.
    var turnstileWidgetId = null; // set by turnstile.render
    var turnstileToken = ''; // latest token from the success callback
    var turnstileLoading = false;
    function loadTurnstile() {
      if (turnstileLoading || !turnstileSiteKey) return;
      var container = document.getElementById('lf-turnstile');
      if (!container) return;
      turnstileLoading = true;
      // Explicit rendering: the api.js `onload` fires this once the global is
      // ready, so we control exactly where/how the widget mounts.
      window.__leadTurnstileRender = function () {
        try {
          if (!window.turnstile || !container) return;
          turnstileWidgetId = window.turnstile.render(container, {
            sitekey: turnstileSiteKey,
            callback: function (t) {
              turnstileToken = t || '';
              if (turnstileToken) turnstileSpent = false;
              flushTurnstileWaiters(turnstileToken);
            },
            'error-callback': function () {
              turnstileToken = '';
              flushTurnstileWaiters('');
            },
            'expired-callback': function () { turnstileToken = ''; },
          });
        } catch (e) {
          console.warn('[lead] turnstile render failed', e);
        }
      };
      var s = document.createElement('script');
      s.async = true;
      s.defer = true;
      s.src =
        'https://challenges.cloudflare.com/turnstile/v0/api.js' +
        '?render=explicit&onload=__leadTurnstileRender';
      document.head.appendChild(s);
    }
    // Read the freshest token available at submit time. Prefer the live widget
    // response (survives an expired-then-refreshed token) and fall back to the
    // last callback value. Returns '' when the key is unset or nothing is ready.
    function currentTurnstileToken() {
      if (!turnstileSiteKey) return '';
      try {
        if (window.turnstile && turnstileWidgetId != null) {
          var r = window.turnstile.getResponse(turnstileWidgetId);
          if (r) return r;
        }
      } catch (_) {}
      return turnstileToken || '';
    }

    // A token is good for ONE siteverify. Cloudflare answers a second use with
    // `timeout-or-duplicate`, the edge quarantines it, and the seller sees "we
    // couldn't send that". Nothing here used to retire a sent token: the widget
    // keeps returning it from getResponse until it is reset, so every second
    // press of the button on the same page (Back from the room and send again,
    // or a retry after a failure) posted the spent one and failed.
    //
    // "Spent" is a flag cleared by the NEXT success callback, not a comparison
    // with the token string: Cloudflare's test keys hand out one dummy token
    // every time, and a string match would call every fresh one spent.
    var turnstileSpent = false;
    var turnstileWaiters = [];
    function flushTurnstileWaiters(t) {
      var waiting = turnstileWaiters;
      turnstileWaiters = [];
      for (var i = 0; i < waiting.length; i++) waiting[i](t);
    }
    // Retire the token just sent and start minting the next one, so it is
    // usually ready before the seller can press the button again.
    function retireTurnstileToken() {
      if (!turnstileSiteKey) return;
      turnstileSpent = true;
      turnstileToken = '';
      try {
        if (window.turnstile && turnstileWidgetId != null) {
          window.turnstile.reset(turnstileWidgetId);
        }
      } catch (_) {}
    }
    // The token to send: the current one, unless it has already been sent, in
    // which case wait (bounded) for the widget to mint the next. On timeout it
    // returns '' and the submit goes without one, same as a widget that never
    // loaded.
    function unspentTurnstileToken() {
      if (!turnstileSpent) return Promise.resolve(currentTurnstileToken());
      if (!window.turnstile || turnstileWidgetId == null) return Promise.resolve('');
      return new Promise(function (resolve) {
        var done = false;
        function finish(tok) {
          if (done) return;
          done = true;
          resolve(turnstileSpent ? '' : tok || '');
        }
        turnstileWaiters.push(finish);
        setTimeout(function () { finish(currentTurnstileToken()); }, 8000);
      });
    }
    // Kick the load on the first interaction with any form control (focus or
    // input) — mirrors the maps loader's deferral so the widget has time to mint
    // a token before the seller reaches submit, without any static 3P request.
    if (turnstileSiteKey) {
      form.addEventListener('focusin', loadTurnstile, { once: true });
      form.addEventListener('input', loadTurnstile, { once: true });
    }

    // ── Timezone cascade: geo → address → phone-hint → user ─────────────────
    // The hidden <select id="lf-timezone"> carries the AUTHORITATIVE clock for
    // the speed-to-lead TCPA calling-window gate (operaitor trusts the submitted
    // value). It's ALWAYS populated: seeded to the brand default at render, then
    // progressively refined by cheap client signals — but a real user choice
    // (`userTouchedTz`) freezes it against any further auto-refinement.
    //
    //   a) on load  → GET /api/geo, snap the edge's IANA zone to the nearest of
    //                 the 7 allowed; source "geo".
    //   b) address  → map the entered state → IANA; source "address".
    //   c) manual   → freeze (userTouchedTz), source "user".
    //
    // The seller is asked to CONFIRM the result in the call room, on its own,
    // after the submit (web/src/features/call-room/timezone-check.tsx).
    //
    // Every step is best-effort and swallows its own errors: a broken geo fetch,
    // a missing cf under `astro dev`, or an unparseable address must NEVER break
    // the form — the brand default simply stands.
    var tzSelect = document.getElementById('lf-timezone');
    var tzSourceEl = document.getElementById('lf-timezone-source');
    // Set true the instant the seller changes the select themselves — freezes
    // the value against geo/address auto-refinement.
    var userTouchedTz = false;

    // Florida keeps a display sentinel value ("fl") in the <select> because it
    // shares the Eastern CLOCK but has its own 8pm close (Fla. Stat. 501.616);
    // `ianaOf` maps it back to a real IANA zone for the submitted clock.
    //
    // The calling-window line ("We'll only call between 8 AM and 9 PM Mountain.")
    // used to sit on this form and was rewritten from here as the state
    // resolved. It moved to the call room's time question on 2026-09-22, where
    // it follows the zone the seller confirms (timezone-check.tsx).
    function ianaOf(v) { return v === 'fl' ? 'America/New_York' : v; }

    // THE calling-window reduction, spliced in from src/scripts/calling-window-core.js
    // at build time (LeadFormScript.astro, WINDOW_SLOT). Defines
    // `effectiveWindowFrom`, `outsideWindow` and `minutesOfHHMM`. Nothing on
    // this form reads it since the calling-window line moved to the call room
    // (2026-09-22); the slot stays because calling-window-core.test.mjs pins
    // the splice, and removing the mirror is its own change.
    //
    // Spliced rather than reimplemented because the same file is imported as a
    // MODULE by src/data/calling-window.ts for the sentence ReiLeadForm renders
    // at build time. One program, two runtimes — the alternative was what was
    // here before: a copy of the reduction that had to be kept in step with the
    // TS one by hand, next to a flat federal `hour < 8 || hour >= 21` deciding
    // the after-hours box, which was a third answer to the same question.
// THE calling-window reduction. One implementation, two runtimes.
//
// This file is consumed twice, deliberately:
//
//   * as a MODULE by src/data/calling-window.ts, for the sentence ReiLeadForm
//     renders at build time;
//   * as SOURCE spliced verbatim into the inlined lead-form.js, for the same
//     sentence rewritten at runtime as the seller's state resolves, and for the
//     after-hours opt-in's own visibility.
//
// It exists because those two were separate implementations of the same rule
// and the page ended up asking three different questions about one window: the
// TS `windowFor`, a re-derivation inside lead-form.js, and a flat federal
// `hour < 8 || hour >= 21` deciding whether to offer the 15-minute box. Three
// answers, one of which quietly hid the box during the exact hour it was for.
//
// CONSTRAINTS THIS FILE HAS TO RESPECT, because of how it is spliced:
//
//   * plain ES5-ish function declarations — the inline script is not a module,
//     so `export` is stripped at splice time (LeadFormScript.astro) and nothing
//     here may rely on module scope, imports, or top-level await;
//   * no DOM and no clock — everything is arguments in, value out, so the same
//     call is testable in node and identical in both runtimes.
//
// The DATA stays in src/data/calling-window.ts and is passed in, because it is
// generated from the backend's table and has its own lockstep test.

/** "20:00" → 1200. Local wall-clock minutes since midnight. */
function minutesOfHHMM(hhmm) {
  var parts = String(hhmm).split(':');
  return parseInt(parts[0], 10) * 60 + parseInt(parts[1] || '0', 10);
}

/**
 * The effective window across every candidate state, MOST-RESTRICTIVE-WINS: the
 * latest morning floor, the earliest evening close, barred if any candidate bars
 * the day. Mirrors Tcpa.effective_start/effective_end — a seller can have
 * several candidate states at once (property in one, phone in another) and the
 * window that governs them is the intersection.
 *
 * `data` is CALLING_WINDOW_DATA ({ federal, states }). `states` is the candidate
 * list. `isSunday` is passed rather than computed: the caller knows the SELLER's
 * local day, and the browser's own is a different question.
 *
 * An empty list yields the federal baseline, which is what the form shows before
 * an address or a phone number narrows anything down.
 */
function effectiveWindowFrom(data, states, isSunday) {
  var start = data.federal.start;
  var end = data.federal.end;
  var barred = false;

  for (var i = 0; i < states.length; i++) {
    var rule = data.states[String(states[i]).toUpperCase()];
    if (!rule) continue;
    var ruleStart = (isSunday && rule.sundayStart) || rule.start;
    if (ruleStart && ruleStart > start) start = ruleStart;
    if (rule.end && rule.end < end) end = rule.end;
    if (rule.barredSundaysAndHolidays && isSunday) barred = true;
  }

  return { start: start, end: end, barred: barred };
}

/**
 * Is `minutes` (local wall-clock minutes since midnight) OUTSIDE the window?
 *
 * A barred day is outside it all day. This is the predicate the after-hours
 * opt-in renders on, and — as the negation of what the dialer permits — the one
 * that decides whether offering the seller a call is a promise we can keep.
 */
function outsideWindow(window, minutes) {
  return (
    window.barred ||
    minutes < minutesOfHHMM(window.start) ||
    minutes >= minutesOfHHMM(window.end)
  );
}


    // The 7 allowed IANA zones (mirror of Operaitor.LeadTimezones + the geo
    // endpoint). Keep in lockstep with the <select> options.
    var TZ_ALLOWED = [
      'America/New_York',
      'America/Chicago',
      'America/Denver',
      'America/Phoenix',
      'America/Los_Angeles',
      'America/Anchorage',
      'Pacific/Honolulu',
    ];

    // Rough UTC offset (standard time, ignoring DST — good enough to pick the
    // nearest bucket) for the 7 allowed zones. Used to snap an arbitrary cf
    // timezone to the nearest allowed one.
    var TZ_OFFSET = {
      'America/New_York': -5,
      'America/Chicago': -6,
      'America/Denver': -7,
      'America/Phoenix': -7,
      'America/Los_Angeles': -8,
      'America/Anchorage': -9,
      'Pacific/Honolulu': -10,
    };
    // Standard-time offsets for a broad set of IANA zones the CF edge might
    // report, so we can snap an arbitrary one to the nearest allowed bucket by
    // offset. Anything not listed → offset lookup fails → we keep the default.
    var CF_TZ_OFFSET = {
      'America/New_York': -5, 'America/Detroit': -5, 'America/Toronto': -5,
      'America/Indiana/Indianapolis': -5, 'America/Kentucky/Louisville': -5,
      'America/Chicago': -6, 'America/Menominee': -6, 'America/Winnipeg': -6,
      'America/Denver': -7, 'America/Boise': -7, 'America/Edmonton': -7,
      'America/Phoenix': -7,
      'America/Los_Angeles': -8, 'America/Vancouver': -8,
      'America/Anchorage': -9, 'America/Juneau': -9, 'America/Sitka': -9,
      'Pacific/Honolulu': -10, 'America/Adak': -10,
    };

    // Snap an arbitrary IANA zone to the nearest of the 7 allowed. Exact match
    // wins; else nearest by standard-time offset (Phoenix loses ties to Denver
    // since Denver is listed first at -7, which is the conservative — earlier
    // DST-closing — reading). Returns null when we can't place it, so the
    // caller keeps the brand default rather than guessing wildly.
    function nearestAllowedZone(tz) {
      if (!tz) return null;
      if (TZ_ALLOWED.indexOf(tz) !== -1) return tz;
      var off = CF_TZ_OFFSET[tz];
      if (typeof off !== 'number') return null;
      var best = null;
      var bestDelta = Infinity;
      for (var i = 0; i < TZ_ALLOWED.length; i++) {
        var z = TZ_ALLOWED[i];
        var d = Math.abs(TZ_OFFSET[z] - off);
        if (d < bestDelta) { bestDelta = d; best = z; }
      }
      return best;
    }

    // Client mirror of Operaitor.UsStateTimezones (collapsed to the 7 allowed
    // zones — Indiana/Detroit → Eastern etc). Multi-zone states pick their most
    // populous zone (TX→Central, FL→Eastern, ID→Mountain). Unknown → null.
    var STATE_TZ = {
      AL: 'America/Chicago', AK: 'America/Anchorage', AZ: 'America/Phoenix',
      AR: 'America/Chicago', CA: 'America/Los_Angeles', CO: 'America/Denver',
      CT: 'America/New_York', DE: 'America/New_York', DC: 'America/New_York',
      FL: 'America/New_York', GA: 'America/New_York', HI: 'Pacific/Honolulu',
      ID: 'America/Denver', IL: 'America/Chicago', IN: 'America/New_York',
      IA: 'America/Chicago', KS: 'America/Chicago', KY: 'America/New_York',
      LA: 'America/Chicago', ME: 'America/New_York', MD: 'America/New_York',
      MA: 'America/New_York', MI: 'America/New_York', MN: 'America/Chicago',
      MS: 'America/Chicago', MO: 'America/Chicago', MT: 'America/Denver',
      NE: 'America/Chicago', NV: 'America/Los_Angeles', NH: 'America/New_York',
      NJ: 'America/New_York', NM: 'America/Denver', NY: 'America/New_York',
      NC: 'America/New_York', ND: 'America/Chicago', OH: 'America/New_York',
      OK: 'America/Chicago', OR: 'America/Los_Angeles', PA: 'America/New_York',
      RI: 'America/New_York', SC: 'America/New_York', SD: 'America/Chicago',
      TN: 'America/Chicago', TX: 'America/Chicago', UT: 'America/Denver',
      VT: 'America/New_York', VA: 'America/New_York', WA: 'America/Los_Angeles',
      WV: 'America/New_York', WI: 'America/Chicago', WY: 'America/Denver',
    };

    // Apply a resolved zone to the select + record provenance, but ONLY when the
    // seller hasn't taken control, the zone is a real allowed option, and no
    // BETTER source has already answered. Pushes a lightweight breadcrumb into
    // the micro-conversion trail for diagnostics.
    //
    // Better, in order (Peter, 2026-09-25): the seller's own device, then where
    // the browser is, then the house. The device clock is what "is this your
    // local time?" asks about; the house says where the house is. This used to
    // be last-writer-wins, so the geo fetch and then the address quietly
    // overwrote the device, and the card proposed the HOUSE's zone. The zone is
    // only the card's first guess now: every rail holds the seller to the
    // nationwide worst case until they answer it.
    var TZ_RANK = { address: 1, geo: 2, device: 3 };
    var tzRank = 0;
    function applyTz(zone, source) {
      if (userTouchedTz || !tzSelect || !zone) return;
      // 'fl' is the Florida display sentinel (a real <option>, mapped to a valid
      // IANA clock via ianaOf) — allow it alongside the 7 IANA zones.
      if (zone !== 'fl' && TZ_ALLOWED.indexOf(zone) === -1) return;
      var rank = TZ_RANK[source] || 0;
      if (rank < tzRank) return;
      tzRank = rank;
      if (tzSelect.value === zone) {
        // Value unchanged but provenance may still advance (geo → address).
        if (tzSourceEl) tzSourceEl.value = source;
        return;
      }
      tzSelect.value = zone;
      if (tzSourceEl) tzSourceEl.value = source;
      try {
        (window.__leadEvents = window.__leadEvents || []).push({
          k: 'timezone_selected', t: Date.now(), v: 0,
        });
      } catch (_) {}
    }

    // Extract a 2-letter US state. Prefers a Places administrative_area_level_1
    // short_name when present; else scans a typed address string for a trailing
    // ", XX" or " XX <zip>" token that is a real USPS code. Returns null on miss.
    var US_STATES = {
      AL:1,AK:1,AZ:1,AR:1,CA:1,CO:1,CT:1,DE:1,DC:1,FL:1,GA:1,HI:1,ID:1,IL:1,IN:1,
      IA:1,KS:1,KY:1,LA:1,ME:1,MD:1,MA:1,MI:1,MN:1,MS:1,MO:1,MT:1,NE:1,NV:1,NH:1,
      NJ:1,NM:1,NY:1,NC:1,ND:1,OH:1,OK:1,OR:1,PA:1,RI:1,SC:1,SD:1,TN:1,TX:1,UT:1,
      VT:1,VA:1,WA:1,WV:1,WI:1,WY:1,
    };
    function stateFromAddressString(s) {
      if (!s) return null;
      var up = String(s).toUpperCase();
      // ", TX 75001" or ", TX," or ", TX" at/near the end.
      var m = up.match(/,\s*([A-Z]{2})\b(?:\s+\d{5}(?:-\d{4})?)?\s*(?:,\s*USA?)?\s*$/);
      if (m && US_STATES[m[1]]) return m[1];
      // Fallback: any standalone 2-letter token followed by a 5-digit ZIP.
      m = up.match(/\b([A-Z]{2})\s+\d{5}(?:-\d{4})?\b/);
      if (m && US_STATES[m[1]]) return m[1];
      return null;
    }

    // Digits-only first-3 of a US phone (handles a leading 1). null if we can't
    // find a plausible 3-digit area code.
    function areaCodeOf(phone) {
      var d = String(phone || '').replace(/\D/g, '');
      if (d.length === 11 && d[0] === '1') d = d.slice(1);
      if (d.length >= 10) return d.slice(0, 3);
      return null;
    }

    // (a) On load: ask the edge for the visitor's IANA zone, snap to nearest
    // allowed, apply as "geo". Fully guarded — any failure (no edge under astro
    // dev, network error, junk payload) is silent and the default stands.
    (function geoPrefill() {
      if (!tzSelect) return;
      try {
        fetch('/api/geo', {
          signal: (typeof AbortSignal !== 'undefined' && AbortSignal.timeout)
            ? AbortSignal.timeout(2500) : undefined,
          priority: 'low',
        })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (g) {
            if (!g) return;
            var zone = nearestAllowedZone(g.timezone);
            if (zone) applyTz(zone, 'geo');
          })
          .catch(function () {});
      } catch (_) {}
    })();

    // (b) After the address is known (Places place_changed OR a typed string):
    // map state → IANA and apply as "address" unless the user already chose.
    function refineTzFromAddress(stateCode) {
      if (userTouchedTz) return;
      var st = stateCode || stateFromAddressString(addressEl && addressEl.value);
      if (!st) return;
      // Florida shares the Eastern clock but ends at 8pm — land the seller on the
      // dedicated Florida option so the shown window + submitted signal reflect it.
      var zone = st === 'FL' ? 'fl' : STATE_TZ[st];
      if (zone) applyTz(zone, 'address');
    }
    // Exposed so the Places `place_changed` closure (defined earlier, fires
    // later) can reach it regardless of declaration order.
    window.__refineTzFromAddress = refineTzFromAddress;

    // ── (a0) THE DEVICE'S OWN ZONE ─────────────────────────────────────────
    //
    // Applied before the geo fetch and beating it, because it is a better answer
    // to the question we are about to ask. `/api/geo` reports where the REQUEST
    // came from — a CDN edge, a VPN exit, a phone on carrier NAT three states
    // away. `Intl` reports what the seller's own clock says, which is exactly
    // what "is this your local time?" means.
    //
    // It is also what makes the split-zone states work without a ZIP table: a
    // Pensacola seller's device says America/Chicago while a FL→zone default
    // says Eastern, and the device is right. The address still drives the RULES
    // (Florida's 8 PM cap) — this is only the clock.
    //
    // Snapped to the 7 allowed options, so an unlisted zone
    // (America/Detroit, America/Indianapolis) never becomes a value the
    // backend allowlist will reject.
    //
    // Snapped by the device's own UTC offsets, not by name. The name lookup
    // (CF_TZ_OFFSET) knew "America/Indiana/Indianapolis", but Safari and Chrome
    // report the older alias "America/Indianapolis", so every Indiana phone
    // lost its reading and fell back to the geo guess, and the lead was held
    // for 8 AM in every US zone (Peter, 2026-09-30). Every alias of a zone
    // shares its offsets, so this cannot miss one. January and July give the
    // standard offset and whether the zone keeps daylight time, which is what
    // tells Denver from Phoenix. An offset outside the seven (Atlantic, abroad)
    // gives null and the geo guess stands.
    function deviceZone() {
      try {
        var z = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (z && TZ_ALLOWED.indexOf(z) !== -1) return z;
        var year = new Date().getFullYear();
        var jan = -new Date(year, 0, 1).getTimezoneOffset();
        var jul = -new Date(year, 6, 1).getTimezoneOffset();
        var std = Math.min(jan, jul) / 60;
        var keepsDst = jan !== jul;
        if (std === -5) return 'America/New_York';
        if (std === -6) return 'America/Chicago';
        if (std === -7) return keepsDst ? 'America/Denver' : 'America/Phoenix';
        if (std === -8) return 'America/Los_Angeles';
        if (std === -9) return 'America/Anchorage';
        if (std === -10) return 'Pacific/Honolulu';
        return null;
      } catch (_) {
        return null;
      }
    }
    applyTz(deviceZone(), 'device');

    // ── The confirm lives in the call room ──────────────────────────────────
    //
    // "It's 9:27 AM Eastern time right now. / Yes, that's my local time / That's
    // not my time zone" used to render here and block the submit. It moved to
    // the room (web/src/features/call-room/timezone-check.tsx), where it is asked
    // on its own after the offer request is in. This form sends only the
    // cascade's guess and its provenance.

    // The disclosure a consent checkbox actually carried, read off the page.
    //
    // OFF THE DOM, not off the constant in src/consent.ts: the artifact has to
    // say what the seller saw. `{brand}` is substituted into these labels at
    // BUILD time, so the constant alone does not name the sender, and a template
    // that drifted from the constant would be recorded as the constant — hiding
    // exactly the drift consent-lockstep.test.mjs exists to catch.
    //
    // The <label> wraps the input, so its text is the checkbox's accessible name
    // and the "text of the checkbox" a court reads. The inner .form-disclaimer
    // is preferred where present because the label also contains the input.
    // Whitespace is collapsed: the markup wraps across lines and the server
    // compares these strings collapsed too (CallRooms.PhoneConsent).
    function consentLabelText(input) {
      if (!input) return null;
      var label = input.closest ? input.closest('label') : null;
      if (!label) return null;
      var body = label.querySelector('.form-disclaimer') || label;
      var text = (body.textContent || '').replace(/\s+/g, ' ').trim();
      return text === '' ? null : text;
    }

    // (d) Any manual change freezes the value, marks it user-sourced, and clears
    // the nudge for good.
    if (tzSelect) {
      tzSelect.addEventListener('change', function () {
        userTouchedTz = true;
        if (tzSourceEl) tzSourceEl.value = 'user';
        try {
          (window.__leadEvents = window.__leadEvents || []).push({
            k: 'timezone_selected', t: Date.now(), v: 0,
          });
        } catch (_) {}
      });
    }

    // The phone lives in step 2; wire its listener once (fires on blur/typing).
    var phoneEl = document.getElementById('lf-phone');
    if (phoneEl) {
    }

    // ── Phone: format as you type, validate on blur ─────────────────────────
    // A FORMATTER, not a template mask. The difference is the whole design:
    // nothing is painted into an empty field, only digits the seller actually
    // typed are re-rendered, and no separator is emitted until the digit AFTER
    // it exists. That last rule is what makes backspace behave — with a
    // dangling "(555) " the formatter re-adds the space the instant it is
    // deleted, and the field looks frozen.
    //
    // US-only NANP is the case where formatting is worth its risk: one fixed
    // length, one universally recognised presentation, and it matches what the
    // seller sees on their own phone's caller ID. Everything else bails out.
    var phoneErrEl = document.getElementById('lf-phone-err');

    // Values this formatter must NOT touch: an international number, an
    // extension, or more digits than a US number has. Leaving them exactly as
    // typed is what keeps the field from silently eating characters — the blur
    // validator then says something true about them instead.
    function phoneUnformattable(raw) {
      var s = String(raw || '');
      if (/[a-wyz]/i.test(s)) return true; // "x", "ext", "extension"
      if (s.indexOf('#') !== -1) return true;
      var d = s.replace(/\D/g, '');
      // A "+" is an explicit country code and only +1 is ours. Tested against
      // the DIGITS, not `/^\+1\b/` — that pattern needs a word boundary after
      // the 1, which a pasted "+15551234567" doesn't have, so the one format a
      // seller is most likely to paste was the one that came out unformatted.
      if (s.indexOf('+') !== -1 && d.charAt(0) !== '1') return true;
      if (d.length === 11 && d[0] === '1') return false;
      return d.length > 10;
    }

    function formatUsPhone(raw) {
      if (phoneUnformattable(raw)) return String(raw || '');
      var d = String(raw || '').replace(/\D/g, '');
      if (d.length === 11 && d[0] === '1') d = d.slice(1);
      d = d.slice(0, 10);
      if (d.length <= 3) return d;
      if (d.length <= 6) return '(' + d.slice(0, 3) + ') ' + d.slice(3);
      return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
    }

    // Re-render, then put the caret back where the seller's DIGITS say it
    // belongs — not at the end. Counting digits rather than characters is what
    // survives the separators moving underneath an edit in the middle.
    function applyPhoneFormat() {
      if (!phoneEl) return;
      var before = phoneEl.value;
      var caret = phoneEl.selectionStart;
      var after = formatUsPhone(before);
      if (after === before) return;
      var digitsBeforeCaret =
        caret == null ? null : before.slice(0, caret).replace(/\D/g, '').length;
      phoneEl.value = after;
      if (digitsBeforeCaret != null && phoneEl.setSelectionRange) {
        var pos = after.length;
        var seen = 0;
        for (var i = 0; i < after.length; i++) {
          if (/\d/.test(after[i])) {
            seen++;
            if (seen === digitsBeforeCaret) {
              pos = i + 1;
              break;
            }
          }
        }
        if (digitsBeforeCaret === 0) pos = 0;
        try {
          phoneEl.setSelectionRange(pos, pos);
        } catch (_) {}
      }
    }

    // The same rules the server has to apply anyway. Returns null when the
    // value is acceptable, otherwise the message to show.
    //
    // NANP structure only: area code and exchange code both start 2–9, neither
    // is an N11 service code. Deliberately NOT the `[2-9][0-8][0-9]` pattern
    // that circulates in blog posts — the "second digit must be 0–8" reserve
    // was released decades ago, and that regex silently rejects 917, 919, 929,
    // 939, 959 and 989. Whether the range is currently ASSIGNED is a question
    // for the backend to flag, never for this form to block on: a lead we
    // can't dial is worth more than a lead we refused.
    function phoneProblem(raw) {
      var s = String(raw || '').trim();
      if (!s) return null; // emptiness is a submit-time concern, not a format one
      // Pull a trailing extension off before anything else; it is legal input.
      s = s.replace(/(?:\s*(?:x|ext\.?|extension|#)\s*\d{1,6})\s*$/i, '').trim();
      var d = s.replace(/\D/g, '');
      // Same digits-based country-code test as phoneUnformattable — `/^\+1\b/`
      // rejected a pasted "+15551234567" as foreign.
      if (s.indexOf('+') !== -1 && d.charAt(0) !== '1') {
        return 'Enter a US phone number. We can only make offers on US properties.';
      }
      if (d.length === 11 && d[0] === '1') d = d.slice(1);
      if (d.length !== 10) return 'Enter all 10 digits, like (555) 123-4567';
      if (
        !/^[2-9]\d{2}[2-9]\d{6}$/.test(d) ||
        /^[2-9]11/.test(d) ||
        /^[2-9]11/.test(d.slice(3))
      ) {
        return 'Enter a valid US phone number, like (555) 123-4567';
      }
      return null;
    }

    // Deliberately permissive, for the same reason `phoneProblem` is: this runs
    // only where the address is LOAD-BEARING — the seller declined the messaging
    // box, so email is the one channel left that needs no consent — and the cost
    // of a false reject there is the whole lead. It catches the typos that make
    // an address unusable (no @, no dot in the domain, a stray space, a trailing
    // comma) and waves through everything else, including the valid-but-unusual
    // shapes a stricter regex is famous for eating. Whether the mailbox actually
    // EXISTS is a bounce for the backend to observe, never a block here.
    function emailProblem(raw) {
      var s = String(raw || '').trim();
      if (!s) return null; // emptiness is decided by the caller, not here
      if (/\s/.test(s)) return 'Remove the space from your email address.';
      var at = s.lastIndexOf('@');
      if (at < 1 || at === s.length - 1) {
        return 'Enter a complete email address, like you@example.com';
      }
      var domain = s.slice(at + 1);
      if (domain.indexOf('.') < 1 || /[.,]$/.test(domain) || domain.indexOf('..') !== -1) {
        return 'Enter a complete email address, like you@example.com';
      }
      return null;
    }

    // ── Validation messages: two places, one call ───────────────────────────
    //
    // Every gate in this form now reports the same way, because they used not
    // to. Phone and email marked their own field and wrote a message under it;
    // the three checkboxes only unhid a paragraph; the address threw the
    // browser's native `reportValidity()` bubble. Three shapes, and none of them
    // said anything next to the button the seller had just pressed — so on step
    // 2, which is tall and carries five gates, pressing submit could look like
    // nothing happening at all.
    //
    // What every failure does now:
    //   * marks the FIELD, so it is findable (`aria-invalid` + `.lf-invalid`,
    //     which is what the red outline hangs off);
    //   * writes the specific message AT that field, where the fix happens;
    //   * writes a summary UNDER THE BUTTON, where the seller is looking;
    //   * moves focus to the field.
    //
    // The two messages are deliberately not the same sentence. At the field it
    // is an instruction ("Enter all 10 digits"); under the button it is a
    // status ("Please fix the highlighted field above"), because repeating the
    // instruction in a second place reads as two separate problems.

    // Which summary belongs to the step the seller is on. Step 1 has its own
    // under Continue; writing step 2's would put the message on a screen the
    // seller cannot currently see.
    //
    // On step 2 that element is SHARED with `showSubmitError` further down,
    // which reports a failed POST in the same place. Deliberate, and they
    // cannot collide: one says the form was not sent because of something on
    // the page, the other because of something on the wire, and the seller is
    // never in both states at once. Distinct function names because the
    // messages are not interchangeable — an earlier version of this named both
    // `showSubmitError`, and the later declaration silently won, which would
    // have told sellers their connection was at fault for a missing tick.
    function submitErrEl() {
      var stepTwoOpen = form.querySelector('.lf-step[data-step="2"]:not([hidden])');
      return document.getElementById(stepTwoOpen ? 'lf-submit-err' : 'lf-step1-err');
    }

    function showValidationSummary(message) {
      var el = submitErrEl();
      if (!el) return;
      if (message) {
        el.textContent = message;
        el.hidden = false;
      } else {
        el.textContent = '';
        el.hidden = true;
      }
    }

    // Both summaries, for the paths that clear rather than fail: a seller who
    // fixed step 1 and moved on should not leave a stale complaint behind them.
    function clearValidationSummary() {
      var ids = ['lf-step1-err', 'lf-submit-err'];
      for (var i = 0; i < ids.length; i++) {
        var el = document.getElementById(ids[i]);
        if (el) {
          el.textContent = '';
          el.hidden = true;
        }
      }
    }

    // Mark or unmark a field. `.lf-invalid` on the WRAPPER rather than styling
    // `[aria-invalid]` on the input alone: the checkbox gates need the same red
    // treatment, and outlining a 16px checkbox is not a visible highlight.
    function markField(el, invalid) {
      if (!el) return;
      el.setAttribute('aria-invalid', invalid ? 'true' : 'false');
      // Nearest wins: a consent label nested inside a `.field` resolves to the
      // label, which is the box that should light up rather than the whole
      // block around it.
      var target =
        (el.closest && el.closest('.lf-consent, .lf-tz-agree, .field')) || el;
      if (invalid) target.classList.add('lf-invalid');
      else target.classList.remove('lf-invalid');
    }

    var SUMMARY_MESSAGE = 'Please fix the highlighted field above.';

    // Say that this field is wrong, in both places, and DO NOT move the cursor.
    //
    // The no-focus half is load-bearing. This runs from `blur` handlers too, and
    // a blur handler that focuses the field being left puts the seller in a trap
    // they cannot tab out of: leave the phone box with nine digits in it and the
    // cursor snaps straight back. Focus belongs to the submit gate, which is the
    // one caller where the seller ASKED to move on and is owed the field that
    // stopped them.
    //
    // `message` may be null for a gate whose sentence is baked into the markup
    // (the consent boxes ship their own copy and only need unhiding).
    function reportField(fieldEl, errEl, message) {
      markField(fieldEl, true);
      if (errEl) {
        if (message) errEl.textContent = message;
        errEl.hidden = false;
      }
      showValidationSummary(SUMMARY_MESSAGE);
    }

    /** Report, then put the cursor in the offending field. Submit gates only. */
    function failField(fieldEl, errEl, message) {
      reportField(fieldEl, errEl, message);
      if (fieldEl && fieldEl.focus) fieldEl.focus();
    }

    // The inverse. Deliberately does NOT touch the summary: another field may
    // still be wrong, and one field passing is not evidence about the rest.
    function clearField(fieldEl, errEl) {
      markField(fieldEl, false);
      if (errEl) {
        errEl.textContent = '';
        errEl.hidden = true;
      }
    }

    function showEmailError(message) {
      var emailEl = form.querySelector('input[name="email"]');
      var emailErrEl = document.getElementById('lf-email-err');
      if (!emailEl) return;
      if (message) reportField(emailEl, emailErrEl, message);
      else clearField(emailEl, emailErrEl);
    }

    // Report-only, both of them: these are called from `blur` and `input` as
    // well as from the submit gate, and the gate does its own focusing.
    function showPhoneError(message) {
      if (!phoneEl) return;
      if (message) reportField(phoneEl, phoneErrEl, message);
      else clearField(phoneEl, phoneErrEl);
    }

    if (phoneEl) {
      phoneEl.addEventListener('input', function () {
        applyPhoneFormat();
        var problem = phoneProblem(phoneEl.value);
        // Two rules, and the order matters:
        //   * once an error IS showing, clear it live — the moment the value
        //     becomes valid, not at the next blur. This is the half of the
        //     pattern most implementations skip, and it is the half that stops
        //     the field feeling like it is arguing with you.
        //   * otherwise stay silent until 10 digits are in. Telling someone
        //     their number is wrong at the 4th digit is telling them off for
        //     not having finished typing.
        if (phoneEl.getAttribute('aria-invalid') === 'true') {
          if (!problem) showPhoneError(null);
          return;
        }
        var digits = phoneEl.value.replace(/\D/g, '');
        var complete =
          digits.length === 10 || (digits.length === 11 && digits[0] === '1');
        if (complete && problem) showPhoneError(problem);
      });
      // Autofill on iOS/Android does not reliably fire `input`, so reformat
      // defensively here too before validating.
      phoneEl.addEventListener('blur', function () {
        applyPhoneFormat();
        showPhoneError(phoneProblem(phoneEl.value));
      });
      // NOTE: there is deliberately no `focus` handler clearing the error on an
      // empty field. That looks like the right way to avoid nagging someone who
      // tabbed past — but the submit gate below sets "Enter your phone number"
      // and then calls `.focus()` to put the cursor there, so a focus handler
      // wipes the message in the same tick it was written. The nagging it was
      // meant to prevent doesn't happen anyway: `blur` stays silent on an empty
      // field, and the `input` handler clears any showing error the moment the
      // value stops being wrong, which an empty value is.
      //
      // Autofill can land a whole number without a keystroke.
      phoneEl.addEventListener('change', applyPhoneFormat);
    }

    // Same two rules as the phone field, for the same reasons:
    //   * once an error IS showing, clear it the moment the value becomes
    //     valid, rather than making the seller blur to find out they fixed it;
    //   * otherwise say nothing until they leave the field. There is no
    //     "complete" test for a half-typed address the way ten digits is one
    //     for a phone number, so `blur` is the earliest honest moment to judge
    //     it — complaining at `you@` is complaining that someone has not
    //     finished typing.
    // Blur stays quiet on an empty field: this one is genuinely optional, and
    // tabbing past it is an answer, not a mistake. `emailProblem` returns null
    // on empty, so that falls out of the check rather than needing a guard.
    // A brand can make it required (`leadForm.email`), and blur STILL stays
    // quiet on empty, for the phone field's reason: a required field only
    // becomes a complaint once someone tries to submit without it. The submit
    // gate below is where that happens. A brand can also hide it, and then
    // there is no field and none of this is wired.
    var emailFieldEl = form.querySelector('input[name="email"]');
    if (emailFieldEl) {
      emailFieldEl.addEventListener('input', function () {
        if (emailFieldEl.getAttribute('aria-invalid') !== 'true') return;
        if (!emailProblem(emailFieldEl.value)) showEmailError(null);
      });
      // Autofill can land a whole address without a keystroke, and `change`
      // fires where `input` sometimes does not.
      emailFieldEl.addEventListener('blur', function () {
        showEmailError(emailProblem(emailFieldEl.value));
      });
      emailFieldEl.addEventListener('change', function () {
        showEmailError(emailProblem(emailFieldEl.value));
      });
    }

    // The after-hours "call me now" box USED to live here, with its evaluator
    // (local time vs the per-state window, the FL/AL/TX/KY suppression, and
    // the "might an operator be available" fetch). It moved to the call room's
    // time question on 2026-09-22 (Peter: ask it where we ask what time it is,
    // and nowhere else). See Operaitor.CallRooms.AfterHoursInvite.

    // ── Contact lane: SMS/phone vs. anonymous web conference ────────────────
    // The branch that decides what the rest of this form asks for and what the
    // backend is allowed to do with the answer:
    //
    //   phone (default) — number + express TCPA consent + timezone. Outbound.
    //   web             — no number, no consent, no timezone. Inbound only: the
    //                     seller reaches us through their call room, so there is
    //                     no calling window to honor and nothing to opt out of.
    //
    // The hidden #lf-contact-lane input is the authoritative value (it is what
    // rides in FormData and what the edge's required-field flags key on); the
    // buttons' aria-pressed is kept in step with it.
    //
    // Switching lanes DISABLES the hidden lane's inputs rather than just hiding
    // them. Hiding alone would still submit an empty `phone` and an unchecked
    // `consent_agree` from a form that never asked for either — which would look
    // exactly like a phone lead whose seller declined consent, and the backend
    // would be right to refuse to dial it. Disabled controls are omitted from
    // FormData entirely, so a web-lane submission carries no phone keys at all.
    var laneInput = document.getElementById('lf-contact-lane');
    var lanePhoneBox = document.getElementById('lf-lane-phone');
    var laneWebBox = document.getElementById('lf-lane-web');
    // The messaging-consent box lives OUTSIDE #lf-lane-phone (it is stacked
    // under the terms box, which both lanes need), so it does not get toggled
    // for free with the rest of the phone lane and is switched explicitly
    // below. Same mechanism, so the same guarantee holds: in the web lane it is
    // hidden AND its input is disabled, which keeps an unchecked
    // `consent_agree` out of FormData entirely rather than submitting one from
    // a form that never asked.
    var consentBox = document.getElementById('lf-consent-box');
    // Same story, same mechanism, one row higher. The phone field sits OUTSIDE
    // #lf-lane-phone so the optional email can sit BESIDE it — the email belongs
    // to both lanes, and a lane box hides and disables everything inside it. So
    // the phone half carries its own wrapper and is switched here. Without this
    // a web-lane submission carries a phone number, which is the one thing that
    // lane promises in writing it does not collect.
    var phoneField = document.getElementById('lf-phone-field');
    var laneBtns = form.querySelectorAll('[data-lf-lane]');

    function currentLane() {
      return laneInput && laneInput.value === 'web' ? 'web' : 'phone';
    }

    function setLaneBoxEnabled(box, on) {
      if (!box) return;
      box.hidden = !on;
      var controls = box.querySelectorAll('input, select, textarea');
      for (var i = 0; i < controls.length; i++) controls[i].disabled = !on;
    }

    function setLane(next, opts) {
      var lane = next === 'web' ? 'web' : 'phone';
      if (laneInput) laneInput.value = lane;
      setLaneBoxEnabled(lanePhoneBox, lane === 'phone');
      setLaneBoxEnabled(laneWebBox, lane === 'web');
      // BOTH contact-consent boxes follow the phone lane — the call box and the
      // SMS box share `#lf-consent-box`, so this one call covers them and there
      // is no second wrapper to forget. The terms box above them does not move:
      // the web-conference lane forms the same agreement.
      setLaneBoxEnabled(consentBox, lane === 'phone');
      // And so does the phone field itself, for the reason above it.
      setLaneBoxEnabled(phoneField, lane === 'phone');
      for (var i = 0; i < laneBtns.length; i++) {
        laneBtns[i].setAttribute(
          'aria-pressed',
          String(laneBtns[i].dataset.lfLane === lane)
        );
      }
      // Email sits OUTSIDE both lane boxes now, because both lanes want it.
      // Only the web lane explains it: there it is the sole delivery route for
      // the room link. The phone lane's hint ("If you reach out after hours,
      // this is how you'll hear back before morning...") left on 2026-09-22:
      // it is about the after-hours box, and the call room says it beside that
      // box now (timezone-check.tsx).
      //
      // One input rather than one per lane: draftFields() keys off
      // `el.name || el.id` and deliberately includes disabled controls, so two
      // inputs both named `email` would collapse to a single draft key and the
      // later one in document order would overwrite the earlier with its empty
      // value — losing a phone-lane address on every save.
      var emailHintEl = document.getElementById('lf-email-hint');
      if (emailHintEl) emailHintEl.hidden = lane !== 'web';
      // (A stale consent error used to be cleared here. There is no consent
      // error any more — neither contact box can fail — so there is nothing to
      // carry between lanes.)
      // Diagnostic only — measures how many sellers take the anonymous door.
      // Never a conversion: choosing a lane is not an outcome.
      // `opts.silent` suppresses the event for non-user applications: the
      // load-time default and draft restores would otherwise inflate page views.
      if (!(opts && opts.silent) && window.gtag) {
        window.gtag('event', 'contact_lane_selected', {
          lane: lane,
          non_interaction: true,
        });
      }
    }

    for (var li = 0; li < laneBtns.length; li++) {
      laneBtns[li].addEventListener('click', function () {
        setLane(this.dataset.lfLane);
      });
    }

    // ── Draft: surviving the hop to the call room ───────────────────────────
    // A successful submit hands the seller off to `my.<brand_domain>` (the
    // handoff at the bottom of this file) — a cross-document navigation to a
    // different registrable domain. Pressing Back there has to return them to
    // step 2 with everything they typed still in it: the reason to press Back
    // is to fix a wrong digit, and a form that has emptied itself is the point
    // at which they stop rather than retype it.
    //
    // Three different things can happen on that Back, and none of the built-in
    // browser behaviors covers all three:
    //
    //   * bfcache restore — not one line of this script runs again. The DOM is
    //     frozen exactly as the handoff left it: form hidden, success card up,
    //     submit button stuck disabled on "Sending…". Only `pageshow` fires.
    //   * back/forward WITH a re-parse — this script does run again, but it runs
    //     BEFORE the browser puts restored values back into the fields. So
    //     initStepHistory below read an empty address, concluded step 2 was a
    //     dead end asking about no property, demoted to step 1 and — via its
    //     replaceState — stripped `?step=contact` back off the URL. Everything
    //     the seller typed was still in the document, sitting invisibly in the
    //     hidden half of the form.
    //   * a cold load with nothing restored — a hard refresh, or any browser
    //     that declined to repopulate. Only a stored copy rescues that one.
    //
    // sessionStorage, not localStorage: these are the seller's name, phone and
    // address, they are only useful for the length of this visit, and they must
    // not outlive the tab. It is strictly less persistent than the `lead_drafts`
    // localStorage copy submitLead already writes on every attempt.
    //
    // Gated on the lane switch existing — the SAME gate the handoff itself uses
    // at the bottom of this file, and for the same reason. A brand-driven form
    // (BrandLeadForm, from `brand.leadFields`) shares this script but has no
    // `my.<brand_domain>` to be sent to and no steps to come back to, so it has
    // nothing to restore and no reason to hold a seller's name and phone in
    // storage at all.
    var DRAFT_ENABLED = !!laneInput;
    var DRAFT_KEY = 'lf_draft:' + location.pathname;

    // A brand's own window for the draft (`leadForm.draftHours`) or the resume
    // card below (`leadForm.resumeDays`), carried on the form as data-* ONLY
    // when it differs from today's (ReiLeadForm.astro). The build validated it
    // already; this checks again rather than trust markup, and anything absent
    // or unusable is today's constant. The bounds are src/levers.ts's
    // DRAFT_HOURS_RANGE and RESUME_DAYS_RANGE (seller-levers.test.mjs holds the
    // two copies together).
    function formWindow(attr, min, max, fallback) {
      var raw = form.getAttribute(attr);
      if (raw == null || !/^\d+$/.test(raw)) return fallback;
      var n = parseInt(raw, 10);
      return n >= min && n <= max ? n : fallback;
    }

    // Six hours by default: deliberately the edge's own `fill_too_slow`
    // ceiling (functions/api/lead.ts flags a submit whose `_ts_start` is over
    // 6h old). Past that the restored timestamp is flagged, so there was
    // nothing left to rescue. A brand that keeps drafts longer accepts that
    // flag on a submit from one: it is advisory, it marks the lead rather than
    // dropping it, and what it says (a tab left open that long) is true.
    var DRAFT_MAX_AGE_MS = formWindow('data-draft-hours', 1, 72, 6) * 60 * 60 * 1000;
    // Never replayed. The honeypot is not ours to refill, and a Turnstile token
    // is minted for ONE submission — restoring a spent one fails verification,
    // where restoring nothing lets the widget mint a fresh one. Consent fields
    // are excluded because a restored checkbox is a pre-checked consent box on
    // a document the seller never agreed on.
    var DRAFT_SKIP = {
      website: 1,
      'cf-turnstile-response': 1,
      consent_version: 1,
      consent_agree: 1,
      sms_consent_agree: 1,
      // `terms_agree` left on 2026-09-20 with the checkbox. A draft can only
      // skip fields that exist.
      after_hours_call_invited: 1,
      after_hours_invited_at: 1,
      after_hours_shown_time: 1,
    };
    // Set once the answers currently in the form have been accepted by the
    // edge. It is what tells a restore that the success card (not the form) is
    // the state the DOM was left in, and that the primary conversion has
    // already been counted for these answers.
    var draftSubmitted = false;
    // Controlled by PUBLIC_CLEAR_DRAFT_ON_SUBMIT in the build environment.
    // Default (unset) keeps the draft after submit — a testing affordance.
    var KEEP_DRAFT_AFTER_SUBMIT = !clearDraftOnSubmit;

    // Deliberately keyed off `name || id` across form.elements rather than a
    // hand-listed set of fields: this form grows a control every few releases,
    // and a list is the kind of thing that silently stops covering the newest
    // question. Disabled controls are INCLUDED — form.elements keeps them (only
    // FormData drops them), so the inactive lane's answers survive a Back too,
    // and setLane re-disables that box on the way back in.
    function draftFields() {
      var out = {};
      var els = form.elements;
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var key = el.name || el.id;
        if (!key || DRAFT_SKIP[key] || el.tagName === 'BUTTON') continue;
        if (el.type === 'checkbox') out[key] = !!el.checked;
        else if (el.type === 'radio') {
          if (el.checked) out[key] = el.value;
        } else out[key] = el.value;
      }
      return out;
    }

    function draftSave() {
      if (!DRAFT_ENABLED) return;
      try {
        sessionStorage.setItem(
          DRAFT_KEY,
          JSON.stringify({
            v: 1,
            at: Date.now(),
            submitted: draftSubmitted,
            fields: draftFields(),
          })
        );
      } catch (_) {
        // Private mode, disabled storage, quota. A draft is a nicety and never a
        // precondition — every path below degrades to exactly today's behavior.
      }
    }

    function draftLoad() {
      if (!DRAFT_ENABLED) return null;
      try {
        var raw = sessionStorage.getItem(DRAFT_KEY);
        if (!raw) return null;
        var d = JSON.parse(raw);
        if (!d || d.v !== 1 || !d.fields) return null;
        if (!d.at || Date.now() - d.at > DRAFT_MAX_AGE_MS) {
          sessionStorage.removeItem(DRAFT_KEY);
          return null;
        }
        return d;
      } catch (_) {
        return null;
      }
    }

    function draftApply(d) {
      var f = d.fields;
      var els = form.elements;
      // The zone and where it came from are put back only when the seller
      // picked the zone by hand. Anything else was the cascade's guess, and
      // this page has already read the device clock again above. Replaying the
      // draft put a stale "geo" back over that fresh "device" reading, and the
      // rank guard then kept the device from ever taking it back, so the lead
      // was held for the nationwide worst case (Peter, 2026-09-29).
      var replayTz = f.timezone_source === 'user';
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var key = el.name || el.id;
        if (!key || DRAFT_SKIP[key] || el.tagName === 'BUTTON') continue;
        if (!replayTz && (key === 'timezone' || key === 'timezone_source')) continue;
        if (!Object.prototype.hasOwnProperty.call(f, key)) continue;
        if (el.type === 'checkbox') el.checked = !!f[key];
        else if (el.type === 'radio') el.checked = el.value === f[key];
        else el.value = f[key];
      }
      draftSubmitted = !!d.submitted;
      // The loop above also puts back `_ts_start`, which the top of this script
      // just re-stamped with Date.now(). That matters more than it looks: the
      // edge flags a submit whose elapsed fill time is under 2 seconds as
      // `fill_too_fast`, and a seller who comes back and immediately re-sends
      // would otherwise wear a bot's timing signature.
      //
      // A zone the seller picked by hand is frozen against the geo/address
      // cascade for the rest of the visit. Re-assert that freeze, or the
      // cascade would re-run on this fresh document and overwrite the choice
      // that the TCPA calling-window gate is authoritatively keyed on.
      if (replayTz) userTouchedTz = true;
      // Both micro-conversions already fired in the document this draft came
      // from. Their per-document dedupe (convFired, in Base.astro) resets on a
      // re-parse, so without this a Back → Continue would re-count the funnel.
      addressFired = true;
      contactFired = true;
    }

    // Restore BEFORE setLane runs below, so the lane switch paints and
    // enables/disables from the seller's actual choice rather than the default.
    var restoredDraft = draftLoad();
    if (restoredDraft) draftApply(restoredDraft);

    // Debounced, so a fast typist writes one draft per pause rather than one
    // per keystroke. Both events are needed: `input` for typing, `change` for
    // the select, the checkboxes and the programmatic lane writes.
    var draftTimer = null;
    function draftSaveSoon() {
      if (draftTimer) clearTimeout(draftTimer);
      draftTimer = setTimeout(draftSave, 250);
    }
    form.addEventListener('input', draftSaveSoon);
    form.addEventListener('change', draftSaveSoon);
    // `pagehide`, NOT `unload`. An unload listener disqualifies the page from
    // the bfcache in every current browser — it would turn the cheapest Back
    // (no re-parse at all) into the most expensive one, to save a draft on the
    // one path that does not need it. This is also the save that matters most:
    // it is the one that runs on the handoff navigation itself.
    window.addEventListener('pagehide', function () {
      if (draftTimer) {
        clearTimeout(draftTimer);
        draftTimer = null;
      }
      draftSave();
    });

    // ── A walk-sheet test visit ─────────────────────────────────────────────
    // The app's walk sheet links here with the tester's details in the URL
    // FRAGMENT: `#walk-test&first_name=…&last_name=…&phone=…&email=…`. A
    // fragment never leaves the browser — no request, no server log, no
    // crawler, no canonical URL — so the prefill cannot become a second URL of
    // this page for search to index, and no seller's details ride to Google.
    //
    // It fills EMPTY fields only (a restored draft wins) and never a consent
    // box: a pre-ticked consent box is not consent. The address gets only the
    // STREET, and the suggestion list is opened on it, so the tester still
    // picks the full address and the autocomplete (city, state, ZIP, and the
    // time zone read from them) is still what gets tested. It then marks the
    // TAB as a test visit, which
    // site.js reads to keep the ad and analytics tags off for the rest of the
    // visit — a tester's form must not count as a Google Ads conversion — and
    // takes the fragment back off the URL so it is not shared or bookmarked.
    (function walkTestPrefill() {
      var hash = location.hash || '';
      if (!/^#walk-test(&|$)/.test(hash)) return;
      var WALK_FIELDS = ['first_name', 'last_name', 'phone', 'email'];
      var params;
      try {
        params = new URLSearchParams(hash.slice(1));
      } catch (_) {
        return;
      }
      try {
        sessionStorage.setItem('op_walk_test', '1');
      } catch (_) {}
      for (var i = 0; i < WALK_FIELDS.length; i++) {
        var name = WALK_FIELDS[i];
        var value = (params.get(name) || '').trim().slice(0, 120);
        var el = form.elements.namedItem(name);
        if (!value || !el || el.value) continue;
        el.value = value;
        // `change`, not `input`: it runs the phone formatter and saves the
        // draft, without looking like the seller typing.
        el.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var street = (params.get('property_address') || '').trim().slice(0, 120);
      var addr = form.elements.namedItem('property_address');
      if (street && addr && !addr.value) {
        addr.value = street;
        // `input` IS the autocomplete's trigger: it asks the provider for this
        // street and opens the list under it, as if the tester had typed it.
        // A brand with no provider has no combobox, and native autofill keeps
        // the field as it would for a seller.
        var suggest = function () {
          if (addr.getAttribute('role') !== 'combobox') return;
          if (addr.getAttribute('aria-expanded') === 'true') return;
          if (addr.value.trim() !== street) return;
          addr.dispatchEvent(new Event('input', { bubbles: true }));
        };
        suggest();
        // The list closes when the field loses focus; tapping back into the
        // still-unpicked street opens it again.
        addr.addEventListener('focus', suggest);
      }
      try {
        history.replaceState(history.state, '', location.pathname + location.search);
      } catch (_) {}
    })();

    // Apply the default once on load so the DOM's disabled-state matches the
    // rendered lane even before anyone touches the switch.
    if (laneInput) setLane(currentLane(), { silent: true });

    // ── Coming back later: the room they already have ───────────────────────
    // The draft above rescues a Back inside ONE visit. This rescues the other
    // return, the one that used to lose everything: a seller who submitted,
    // went to the call room, closed the tab, and came back to this page a day
    // later. Nothing here could see that room — it is served from
    // `my.<apex>`, a different registrable domain, so no storage of ours is
    // readable from it and none of its is readable from here — so they filled
    // the form again, `newLeadId()` minted a fresh id, and `/start` dutifully
    // built them a SECOND room. The first one kept the intake answers they had
    // already given and the place in the hold queue they had already earned,
    // and nobody was ever sent back to it.
    //
    // What is stored is a POINTER and never the answers: a lead id and a brand.
    // localStorage rather than the draft's sessionStorage, because outliving
    // the tab is the entire point — which is exactly why it must not carry a
    // name, a phone number or an address. Landing pages get opened on shared
    // laptops and family phones, and leaving a seller's details on one until
    // somebody clears site data is a worse bargain than the one this is making.
    // The answers stay on the room, behind the room's own token, where they
    // already were.
    //
    // Same gate as the draft and the handoff (`laneInput`), plus a room to go
    // back to. A brand-driven form has neither.
    var ROOM_ENABLED = !!laneInput && !!(form.dataset.talkBase || '');
    var ROOM_KEY = 'lf_room:' + ((identity && identity.brand) || '');
    // Past this the pointer is dropped without asking anyone. Seven days by
    // default. It is not a link lifetime: the card sends the seller through
    // `/start`, which signs a fresh Seller Portal link every time, so no
    // `room_link_days` a Script sets can leave this pointing at an expired one.
    // It is the backstop for the answer we never get — a device that spent a
    // week offline, or a status endpoint that is down every time this seller
    // happens to visit.
    //
    // A brand may shorten or lengthen it (`leadForm.resumeDays`, 1 to 90; see
    // formWindow above). Longer never offers a dead room: the card still shows
    // only when /api/room-status says the room is live, and a "no" clears the
    // pointer on the spot. What a longer window costs is one status request
    // per page load for a seller who still holds a pointer.
    var ROOM_MAX_AGE_MS = formWindow('data-resume-days', 1, 90, 7) * 24 * 60 * 60 * 1000;

    function roomPointerSave(leadId) {
      if (!ROOM_ENABLED || !leadId) return;
      try {
        localStorage.setItem(
          ROOM_KEY,
          JSON.stringify({
            v: 1,
            lead: leadId,
            brand: (identity && identity.brand) || '',
            at: Date.now(),
          })
        );
      } catch (_) {
        // Private mode, disabled storage, quota. Degrades to exactly the old
        // behaviour: the next visit starts a new request.
      }
    }

    function roomPointerClear() {
      try {
        localStorage.removeItem(ROOM_KEY);
      } catch (_) {}
    }

    function roomPointerLoad() {
      if (!ROOM_ENABLED) return null;
      try {
        var raw = localStorage.getItem(ROOM_KEY);
        if (!raw) return null;
        var p = JSON.parse(raw);
        if (!p || p.v !== 1 || !p.lead || !p.brand) return null;
        if (!p.at || Date.now() - p.at > ROOM_MAX_AGE_MS) {
          roomPointerClear();
          return null;
        }
        return p;
      } catch (_) {
        return null;
      }
    }

    // Where the resume button goes. Built here rather than left to the
    // `data-call-room` decorator in Base.astro, for the same reason the submit
    // handoff builds its own: that decorator runs on DOMContentLoaded, and this
    // link has no href until a network round-trip has finished.
    //
    // No `mode`. The submit handoff sends a first-time seller to `intake`,
    // which is the block of optional follow-up questions — the wrong place to
    // land somebody who has already answered them. With no mode the room opens
    // on its own default view, which is the one that offers to start the call.
    function roomResumeHref(pointer) {
      return (
        (form.dataset.talkBase || '').replace(/\/+$/, '') +
        '/start?b=' + encodeURIComponent(pointer.brand) +
        '&lead=' + encodeURIComponent(pointer.lead) +
        roomAttributionQuery(readAttribution())
      );
    }

    // Ask before offering. `/start` reuses a room only while it is open or
    // connected (CallRooms.live_room_for_lead/2, which is the query behind this
    // endpoint) — so without this check the card would promise "pick up where
    // you left off" to a seller whose call finished last week and then mint
    // them an empty new room, which is a worse experience than the blank form
    // it replaced.
    function roomResumeInit() {
      var card = document.getElementById('lf-resume');
      var go = document.getElementById('lf-resume-go');
      var dismiss = document.getElementById('lf-resume-dismiss');
      if (!card || !go || !dismiss) return;
      var pointer = roomPointerLoad();
      if (!pointer) return;

      fetch(
        '/api/room-status?brand=' +
          encodeURIComponent(pointer.brand) +
          '&lead=' +
          encodeURIComponent(pointer.lead),
        { headers: { Accept: 'application/json' }, cache: 'no-store' }
      )
        .then(function (res) {
          // 503 is the edge saying "we could not find out" (origin down, no
          // ROOM_STATUS_URL configured, timeout). That is NOT an answer about
          // this seller, so the pointer survives to be asked again next visit.
          // Distinguishing it from a real "nothing here" is the whole reason
          // functions/api/room-status.ts has three outcomes instead of two.
          if (!res.ok) return null;
          return res.json();
        })
        .then(function (data) {
          if (!data) return;
          if (data.resumable !== true) {
            // Definitive. Stop asking on every page load for the rest of the
            // window.
            roomPointerClear();
            return;
          }
          go.href = roomResumeHref(pointer);
          go.addEventListener('click', function () {
            // Using the room is what keeps the pointer alive: the window (seven
            // days unless the brand set its own) runs from the last time they
            // came back, not from the submit.
            roomPointerSave(pointer.lead);
            // Same event both other doors report, with the SAME transaction_id
            // the original handoff used — so a seller who returns three times
            // is one conversion in Ads (order-id dedupe within the action)
            // rather than three off a single click.
            fireRoomDoor(pointer.lead);
          });
          dismiss.addEventListener('click', function () {
            roomPointerClear();
            card.hidden = true;
            // Focus has to go somewhere it makes sense; the control that was
            // just pressed is gone. The first thing they asked for is the
            // address, which is also what "start a new request" means.
            if (addressEl) addressEl.focus();
          });
          card.hidden = false;
        })
        .catch(function () {
          // Offline, blocked, or no fetch at all. Show nothing and keep the
          // pointer — the form underneath is untouched and still works.
        });
    }

    // Wrapped, and the wrapping is not decoration. Everything that makes this
    // form WORK — the two steps, the validation, the submit handler — is wired
    // below this line, so a synchronous throw here (no `fetch`, a storage API
    // that raises rather than returns null, anything) would leave the seller
    // looking at a form whose buttons do nothing. A convenience for returning
    // visitors must never be able to break the page for new ones.
    try {
      roomResumeInit();
    } catch (_) {}

    // ── Two-step flow: address (step 1) → contact (step 2) ──────────────────
    // Address-first matches the iBuyer pattern and keeps step 1 low-friction;
    // gating contact behind it means a step-1 abandoner is a clean drop (no
    // half-captured PII), and firing a step event lets us watch funnel drop-off
    // without needing an underpowered A/B test.
    var step1 = form.querySelector('[data-step="1"]');
    var step2 = form.querySelector('[data-step="2"]');
    var continueBtn = document.getElementById('lf-continue');
    var backBtn = document.getElementById('lf-back');

    // ── Partial-lead capture (address ONLY) ─────────────────────────────────
    // Banks the property address server-side when the visitor clicks the
    // step-1 Continue button — an affirmative act, disclosed by the notice
    // rendered above the address field (LeadForm.astro) — so a step-2
    // abandoner is still a followable near-miss. Legal guardrails (per legal
    // review — requirements, not preferences):
    //   * fires ONLY on the Continue click, never per-keystroke and never on
    //     blur (typing alone is not an affirmative act);
    //   * sends the ADDRESS plus the same non-PII context submitLead sends
    //     (attribution, identity, tz, page, shown number) — NEVER name/phone/
    //     email, even if typed later: a typed-but-unsubmitted phone number is
    //     consent-less, so contact fields ride the real submit only;
    //   * at most once per distinct address value per session (sessionStorage
    //     set) — re-fires only when the address itself changed;
    //   * fire-and-forget with keepalive + silent catch — must never block,
    //     delay, or break the step transition.
    function sendPartialLead(addr) {
      try {
        var key = 'partial_sent_addresses';
        var sent = [];
        try {
          sent = JSON.parse(sessionStorage.getItem(key) || '[]');
        } catch (_) {}
        if (!Array.isArray(sent)) sent = [];
        if (sent.indexOf(addr) !== -1) return; // this exact value already sent
        sent.push(addr);
        // Keep the session set bounded; oldest entries age out first.
        try {
          sessionStorage.setItem(key, JSON.stringify(sent.slice(-20)));
        } catch (_) {}

        var payload = {
          // Fresh per-capture id — the backend banks partials in the same
          // idempotent lead_id-keyed table as submits.
          lead_id: newLeadId(),
          intent: 'partial',
          property_address: addr,
          // The tz the cascade has resolved so far (geo/default at step 1;
          // "fl" sentinel maps to its real IANA clock, mirroring submit).
          timezone: tzSelect && tzSelect.value ? ianaOf(tzSelect.value) : null,
          timezone_source:
            (tzSourceEl && tzSourceEl.value) || 'default',
          attribution: readAttribution(),
          session_key: readSessionKey(),
          visitor_key: readVisitorKey(),
          identity: identity,
          source: location.hostname,
          path: location.pathname,
          referrer: document.referrer || null,
          events: (window.__leadEvents || []).slice(0, 50),
          contract_version: 1,
          // Bot-check signals the edge expects (same as the submit path).
          _ts_start: (tsField && tsField.value) || '',
          _client: 'ok',
        };
        // Mirror submit: the Florida display sentinel carries a state signal.
        if (tzSelect && tzSelect.value === 'fl') {
          payload.identity = Object.assign({}, payload.identity, { state: 'FL' });
        }
        // Which location-specific number this visitor was shown (non-PII —
        // it's OUR number). Same read as the submit path.
        try {
          payload.presented_number =
            JSON.parse(sessionStorage.getItem('shown_number')) ||
            window.__locNumber ||
            null;
        } catch (_) {
          payload.presented_number = window.__locNumber || null;
        }
        fetch('/api/partial-lead', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          keepalive: true,
        }).catch(function () {});
      } catch (_) {
        // Silent by design — partial capture must never break the form.
      }
    }

    // ── Steps as real history entries ───────────────────────────────────────
    // Step 2 used to be a `hidden` swap and nothing else: the URL never moved,
    // so the browser Back button left the site entirely from a form the seller
    // was halfway through. It is a query param (`?step=contact`) rather than a
    // path segment or a hash for three reasons specific to this site:
    //
    //   * these pages are statically generated (~4.7k of them). A path segment
    //     would 404 on refresh unless every city page got a second HTML file
    //     built for it — doubling the build to buy nothing.
    //   * `sendPartialLead` and the submit body both send `path:
    //     location.pathname`. A query param leaves `pathname` alone, so those
    //     fields keep meaning exactly what they have always meant.
    //   * a hash fires no pageview, so the two steps would be indistinguishable
    //     in analytics — which is half the point of giving step 2 a URL.
    //
    // The URL is always rebuilt from `new URL(location.href)`, never
    // concatenated: `gclid`, the `utm_*` suffix and `?loc=` all live in the
    // query string, and a refresh at step 2 must not drop the click that paid
    // for this visit.
    var STEP_PARAM = 'step';
    var STEP2_VALUE = 'contact';
    var baseTitle = document.title;
    var step2Title = 'Your details — ' + baseTitle;
    var liveEl = document.getElementById('lf-live');

    function stepUrl(step) {
      var u = new URL(location.href);
      if (step === 2) u.searchParams.set(STEP_PARAM, STEP2_VALUE);
      else u.searchParams.delete(STEP_PARAM);
      return u.pathname + u.search + u.hash;
    }

    function currentStepFromUrl() {
      try {
        return new URL(location.href).searchParams.get(STEP_PARAM) === STEP2_VALUE
          ? 2
          : 1;
      } catch (_) {
        return 1;
      }
    }

    // PAINT ONLY. renderStep never touches history — that split is what makes
    // the double-push bug (Back → Continue → Back does nothing) impossible: the
    // history cursor moves in exactly one place, and this function is driven BY
    // it rather than racing it.
    function renderStep(step, opts) {
      opts = opts || {};
      var toTwo = step === 2;
      if (step1) step1.hidden = toTwo;
      if (step2) step2.hidden = !toTwo;
      // The title is the first thing a screen reader reads after a history
      // move, and it is what the browser's own back/forward menu lists — leave
      // it stale and the two entries are indistinguishable.
      document.title = toTwo ? step2Title : baseTitle;

      if (opts.focus !== false) {
        // The heading, NOT the first input. Dropping a screen-reader user onto
        // "First name" announces a field with no clue that the page moved;
        // announcing "Step 2 of 2, how we reach you" says where they are.
        var h = document.getElementById(
          toTwo ? 'lf-step2-heading' : 'lf-step1-heading'
        );
        if (h && h.focus) h.focus();
        // Backstop: NVDA/Firefox and VoiceOver/Safari often announce nothing at
        // all on a same-document transition, focus move or not.
        if (liveEl) {
          liveEl.textContent = toTwo
            ? 'Step 2 of 2, how we reach you'
            : 'Step 1 of 2, your property address';
        }
      }
      // The two steps are very different heights; without this a Back lands the
      // seller in the middle of the card.
      if (opts.scroll !== false && form.scrollIntoView) {
        form.scrollIntoView({ block: 'start' });
      }
    }

    function goToStep2() {
      var addr = ((addressEl && addressEl.value) || '').trim();
      var addressErrEl = document.getElementById('lf-address-err');
      if (!addr) {
        // Was `reportValidity()` — the browser's own bubble, in the browser's
        // words, positioned by the browser, and gone again on the next click.
        // The rest of the form marks the field and writes a message that stays;
        // the first field the seller ever touches should not be the one
        // exception.
        failField(addressEl, addressErrEl, 'Enter the property address');
        return;
      }
      clearField(addressEl, addressErrEl);
      clearValidationSummary();
      // Telemetry: the seller advanced on an address they TYPED rather than one
      // they picked. This is the number the provider comparison is really
      // about — suggestions nobody takes are doing nothing for the address
      // quality that `address_entered` implies, however fast they arrived.
      // Recorded only when a provider was actually running: with no key at all
      // there is no dropdown to decline.
      if (acStats.provider && !acStats.picked && !acStats.manual) {
        acStats.manual = true;
        if (acStats.time_to_commit_ms === null) {
          acStats.time_to_commit_ms = acSinceFirstKey();
        }
      }
      // Ensure the address micro-conversion fires even for manually-typed
      // addresses (autocomplete would have set addressFired already).
      if (!addressFired && window.__fireConversion) {
        // value omitted — inherits leadValueMap['address_entered'] from config.
        window.__fireConversion('address_entered', { currency: 'USD' });
        addressFired = true;
      }
      // Timezone cascade (b) for TYPED addresses: parse a state out of the
      // string (autocomplete already refined via the structured place). No-op
      // when the user has already picked a zone, or nothing parses.
      refineTzFromAddress(null);
      // Partial-lead capture: bank the ADDRESS server-side now (disclosed by
      // the notice above the field), after validation and after the tz
      // refinement so the payload carries the freshest zone. Fire-and-forget —
      // never blocks or delays the step transition.
      sendPartialLead(addr);
      // Funnel step: reached the contact step (secondary signal for drop-off).
      // Deduped (Back → Continue re-enters here) and routed through the shared
      // helper so it can fire an Ads conversion if ever given a label.
      if (!contactFired) {
        contactFired = true;
        if (window.__fireConversion) {
          // value omitted — inherits leadValueMap['contact_step'] from config.
          window.__fireConversion('contact_step', { currency: 'USD' });
        }
      }
      // Guarded, so Back → Continue → Back → Continue never grows history past
      // one entry. (pushState also truncates forward history, so the depth is
      // capped at +1 forever.) The push happens inside a click handler on
      // purpose: Chrome's history-manipulation intervention SKIPS entries
      // created without user activation, which would silently defeat this.
      if ((history.state && history.state.lfStep) !== 2) {
        history.pushState({ lfStep: 2 }, '', stepUrl(2));
      }
      renderStep(2);
    }

    // The in-form Back button delegates to real history rather than repainting.
    // Repainting directly would leave the seller looking at step 1 while the
    // history cursor still said step 2 — and then Forward would appear broken.
    function goToStep1() {
      if ((history.state && history.state.lfStep) === 2) history.back();
      else renderStep(1);
    }

    // Back AND Forward both land here, and both are same-document — the inputs
    // were never destroyed, so everything the seller typed is still there. The
    // one rule: never reset the form or re-render step 2's markup from here.
    window.addEventListener('popstate', function (e) {
      renderStep((e.state && e.state.lfStep) === 2 ? 2 : currentStepFromUrl());
    });

    (function initStepHistory() {
      // A cold load at `?step=contact` (bookmark, shared link) has an EMPTY
      // address field, so step 2 would be a dead end asking for contact details
      // about no property. Normalize to step 1 and rewrite the URL in place.
      //
      // The address is read AFTER the draft restore above, which is the whole
      // reason that restore is placed where it is. A Back from the call room
      // re-parses this page with the fields not yet repopulated, so this test
      // used to see "empty" for a seller who had filled in everything, demote
      // them to step 1, and strip `?step=contact` off the URL on the way.
      var wanted = currentStepFromUrl();
      if (wanted === 2 && !((addressEl && addressEl.value) || '').trim()) {
        wanted = 1;
      }
      try {
        history.scrollRestoration = 'manual';
      } catch (_) {}
      // replaceState, NOT pushState: this stamps the entry the seller is
      // already on (so a Back to it carries state) without adding one. It also
      // seeds `history.state` before any event can arrive, which is what makes
      // the spurious initial `popstate` some older browsers fire harmless —
      // renderStep is idempotent, so it just repaints the same step.
      try {
        history.replaceState({ lfStep: wanted }, '', stepUrl(wanted));
      } catch (_) {}
      renderStep(wanted, { focus: false, scroll: false });
    })();

    // Put the form back into a usable state after a submit. Only ever reached
    // by coming BACK to this page, and idempotent by design: on the REI handoff
    // path the form was never hidden (there is no interstitial), so the only
    // thing actually stale is the submit button — but a brand form, or an REI
    // page with no room configured, does come back showing the success card.
    var submitBtnEl = form.querySelector('button[type="submit"]');
    if (submitBtnEl && !submitBtnEl.dataset.lfLabel) {
      submitBtnEl.dataset.lfLabel = submitBtnEl.textContent;
    }
    function showFormAgain() {
      form.hidden = false;
      success.hidden = true;
      if (submitBtnEl) {
        // The submit path disables the button and rewrites its label to
        // "Sending…" and then navigates away, so a bfcache restore hands it
        // back frozen in that state — a dead control on a form we just asked
        // the seller to use.
        submitBtnEl.disabled = false;
        if (submitBtnEl.dataset.lfLabel) {
          submitBtnEl.textContent = submitBtnEl.dataset.lfLabel;
        }
      }
    }

    // The bfcache path, and the ONLY hook that runs on it: a restore replays
    // this document without re-executing a line of this script, so
    // initStepHistory never fires, the success card is still up and
    // history.state still says step 2.
    //
    // Guarded on `persisted` because a re-parsed back/forward is already
    // handled by initStepHistory above (with a fresh DOM, where the success
    // card starts hidden and there is nothing to undo).
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      // Same gate as the draft and the handoff: only a form that sends the
      // seller to another host has a Back worth undoing. A brand form's success
      // card is the end of its flow, and coming back to it should still show
      // "we got it" rather than a form the seller has already sent.
      //
      // Unconditional (not "only if something looks hidden"): the REI handoff
      // leaves the form VISIBLE and only the submit button frozen on "Sending…",
      // so a state test on `hidden` would skip the one case that now matters.
      // When the draft was cleared at submit (production mode), the frozen
      // success card is the honest state — leave it. Otherwise put the form
      // back in front of the seller. The !draftSubmitted arm covers the case
      // where they navigated away from step 1 without submitting.
      if (DRAFT_ENABLED && (KEEP_DRAFT_AFTER_SUBMIT || !draftSubmitted)) {
        showFormAgain();
      }
      // Idempotent repaint. On a restore that never submitted anything this is
      // the only thing that happens, and it just re-asserts the step the URL
      // already names.
      renderStep(currentStepFromUrl(), { focus: false });
    });

    if (continueBtn) continueBtn.addEventListener('click', goToStep2);
    if (backBtn) backBtn.addEventListener('click', goToStep1);
    // Enter in the address field advances instead of submitting the form —
    // unless the suggestion listbox is open with an option highlighted, in
    // which case that Enter picks the address and this press is spent.
    if (addressEl) {
      addressEl.addEventListener('keydown', function (e) {
        if (acKeydown(e)) return;
        if (e.key === 'Enter') {
          e.preventDefault();
          goToStep2();
        }
      });
    }

    async function submitLead(payload) {
      // Local-storage backup so a lead is never lost even if the network fails.
      try {
        var existing = JSON.parse(localStorage.getItem('lead_drafts') || '[]');
        existing.push(payload);
        localStorage.setItem('lead_drafts', JSON.stringify(existing));
      } catch (_) {}
      try {
        var res = await fetch('/api/lead', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        // The ONLY success signal is an explicit `accepted: true` in the JSON
        // body — the edge sends it only when the lead cleared every hard gate
        // and was forwarded. A quarantined submission still returns HTTP 200
        // (so bots get no signal) but WITHOUT `accepted`, so res.ok alone must
        // never gate success or a conversion. Body may be unparseable on a real
        // network/5xx failure → accepted stays false.
        //
        // `undeliverable: true` narrows WHY it wasn't accepted: the edge has no
        // webhook configured, so no retry can ever land. Preview builds are the
        // normal case (secrets are production-scope only). Absent on every other
        // not-accepted outcome, so those still read as retryable.
        var accepted = false;
        var undeliverable = false;
        try {
          var json = await res.json();
          accepted = !!(json && json.accepted === true);
          undeliverable = !!(json && json.undeliverable === true);
        } catch (_) {}
        return {
          ok: res.ok,
          status: res.status,
          accepted: accepted,
          undeliverable: undeliverable,
        };
      } catch (e) {
        console.warn('[lead] submit failed', e);
        return { ok: false, status: 0, accepted: false, undeliverable: false };
      }
    }

    // Inline submit-error affordance. LeadForm.astro is owned by another surface,
    // so the element is created on demand and inserted just before the submit
    // button (reusing the existing .lf-consent-err styling). Shown only on a
    // failed/non-2xx POST; the retry affordance is the re-enabled submit button.
    //
    // `undeliverable` (from /api/lead — see the !env.LEAD_WEBHOOK_URL branch in
    // functions/api/lead.ts) swaps the copy, because the default message would
    // be a wrong diagnosis: nothing is wrong with the visitor's connection and
    // no number of retries will land. Same wording on preview and production on
    // purpose — the fact is identical ("this form has no destination"), only the
    // reason differs (intentional on a *.pages.dev preview, a misconfigured box
    // on the real domain), and a visitor can't act on the difference. The button
    // is still re-enabled by the caller either way: telling someone not to retry
    // is honest, trapping them in a dead form is not.
    function showSubmitError(undeliverable) {
      var err = document.getElementById('lf-submit-err');
      if (!err) {
        err = document.createElement('p');
        err.id = 'lf-submit-err';
        err.className = 'lf-consent-err';
        err.setAttribute('role', 'alert');
        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn && submitBtn.parentNode) {
          submitBtn.parentNode.insertBefore(err, submitBtn);
        } else {
          form.appendChild(err);
        }
      }
      err.textContent = undeliverable
        ? "This form isn't connected right now, so your details weren't sent. " +
          "Retrying won't help — please call us instead."
        : "Sorry — we couldn't send that. Please check your connection and try again.";
      err.hidden = false;
    }
    function clearSubmitError() {
      var err = document.getElementById('lf-submit-err');
      if (err) err.hidden = true;
    }

    // Unhide the .form-success__opt block wrapping a success-panel CTA — its
    // heading and its description travel with the button. Also what makes the
    // divider between the two options appear, since that rule is scoped to
    // :not([hidden]) siblings.
    function revealSuccessOption(btn) {
      var opt = btn && btn.closest && btn.closest('.form-success__opt');
      if (opt) opt.hidden = false;
    }

    // Both success-panel CTAs are DOORS INTO THE CALL ROOM, so both report the
    // same thing: `call_room_click`, the cheap event whose whole job is "left the
    // landing domain for the room while the click id was still clean".
    //
    // They used to report `call_requested` ($800) and `schedule_click`, which are
    // the events the ROOM fires when a seller actually connects or actually opens
    // the slot picker. Firing them here meant one seller produced two hits on one
    // Google Ads website action from two different domains — and because those
    // actions count One per click, the LANDING hit is the one that counted. A
    // seller who tapped "Talk now" and then closed the tab booked the full $800
    // "connected" conversion without ever reaching the room, which is exactly the
    // reward-the-click failure the room was moved onto the pixel to avoid.
    //
    // Order ID dedupe did not save it either: it de-dupes within ONE action, so
    // it collapsed the pair to a single conversion — the wrong one, at the wrong
    // moment, with the wrong value.
    //
    // Deliberately not deduped across the two buttons here: `__fireConversion`
    // already dedupes the Ads ping per event name for the page load, so a seller
    // who taps both reports one Ads conversion (GA4 sees both taps, which is the
    // honest count of intent).
    function fireRoomDoor(leadId) {
      if (!window.__fireConversion) return;
      window.__fireConversion('call_room_click', {
        currency: 'USD',
        transaction_id: leadId,
      });
    }

    // Per-submission identifier. Sent with the gtag event as `transaction_id`
    // AND with the POST body as `lead_id`. This is the join key between the
    // client-side conversion in Google Ads and the server-side lead record —
    // when a deal closes, we upload a Conversion Adjustment keyed to this ID
    // to restate the $600 estimate as the actual closed-deal value.
    // The two ids Base.astro mints for the landing beacons, READ here so a
    // submit lands on the arrival already recorded for this visit instead of
    // opening a second one. Same storage keys, deliberately: they are the join
    // between `lead_submissions` and `lead_landings`.
    //
    // Read-only on purpose. Minting one here would invent a session the
    // beacons never reported, which is worse than sending nothing — the
    // backend records the arrival from the submit itself when these are absent.
    function readSessionKey() {
      try {
        return sessionStorage.getItem('imp_session') || null;
      } catch (_) {
        return null;
      }
    }

    function readVisitorKey() {
      try {
        return localStorage.getItem('lp_visitor') || null;
      } catch (_) {
        return null;
      }
    }

    function newLeadId() {
      if (window.crypto && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
      }
      // Fallback for old browsers — millisecond-unique enough for this use.
      return (
        'lead_' +
        Date.now().toString(36) +
        '_' +
        Math.random().toString(36).slice(2, 10)
      );
    }

    // E.164 phone normalization for Enhanced Conversions matching.
    // "(888) 974-2345" → "+18889742345". Strict — strips non-digits, adds +1
    // for 10-digit US numbers. Required format for Google's ECL hashing.
    function normalizePhone(s) {
      var digits = String(s || '').replace(/\D/g, '');
      if (digits.length === 10) return '+1' + digits;
      if (digits.length === 11 && digits[0] === '1') return '+' + digits;
      return digits ? '+' + digits : '';
    }

    // The attribution that has to ride the HANDOFF URL, not just the POST body.
    //
    // The call room lives on `my.<apex>` — a different registrable domain from
    // this landing site — so the Google Ads first-party cookie set here is
    // unreadable there and a conversion fired in the room has nothing to
    // attribute itself to. The static `data-call-room` CTAs are decorated by
    // Base.astro for exactly this reason; the FORM handoff was not, so a seller
    // who submitted (the majority path) arrived at a room that knew nothing
    // about the click that paid for them. CallRoomController.start persists
    // these onto the room row.
    //
    // First-touch wins, latest-touch is the fallback — that is the click Google
    // Ads attributes the eventual conversion to. Every value is length-capped
    // server-side; nothing here is trusted.
    function roomAttributionQuery(attribution) {
      var first = (attribution && attribution.first) || {};
      var latest = (attribution && attribution.latest) || {};
      var pick = function (key) {
        return first[key] || latest[key] || '';
      };
      var pairs = [
        ['gclid', pick('gclid')],
        ['gbraid', pick('gbraid')],
        ['wbraid', pick('wbraid')],
        ['campaign', pick('utm_campaign')],
        ['loc', pick('loc')],
        ['path', location.pathname],
      ];
      var out = '';
      for (var i = 0; i < pairs.length; i++) {
        if (pairs[i][1]) {
          out += '&' + pairs[i][0] + '=' + encodeURIComponent(pairs[i][1]);
        }
      }
      return out;
    }

    // Read attribution from localStorage (populated by Base.astro on every
    // page load). Returns merged object: first-touch + latest-touch + form
    // page context. The form-submit handler attaches this to the POST body.
    function readAttribution() {
      var out = { first: null, latest: null };
      try {
        var f = localStorage.getItem('attribution_first');
        var l = localStorage.getItem('attribution_latest');
        if (f) out.first = JSON.parse(f);
        if (l) out.latest = JSON.parse(l);
      } catch (_) {}
      return out;
    }

    // Which submit button was pressed — "request" or "call". Both post the same
    // payload; the action only decides where on `my.<brand_domain>` the seller
    // lands afterwards (the optional-intake block vs. straight into the room).
    // The REI form currently ships only the "request" button, so "call" is
    // unreachable there — the branch is kept because it costs nothing and a
    // brand that wants the straight-to-room path back only has to add a button.
    // Captured on click because `document.activeElement` is unreliable by the
    // time the submit event fires on some mobile browsers.
    var pendingAction = 'request';
    var lastLeadId = '';
    var actionBtns = form.querySelectorAll('[data-lf-action]');
    for (var ai = 0; ai < actionBtns.length; ai++) {
      actionBtns[ai].addEventListener('click', function () {
        pendingAction = this.dataset.lfAction === 'call' ? 'call' : 'request';
      });
    }

    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      // NO CONSENT GATE IS LEFT (2026-09-20). The contact boxes stopped
      // blocking on 2026-08-11 and the terms box stopped existing today, so
      // nothing a seller can decline stops a submit. What still gates is the
      // data — the phone number, the timezone attestation, the fields the
      // offer needs — and none of that is a permission. Form is novalidate, so
      // those are enforced in JS below.
      //
      // Phone gate — PHONE LANE ONLY, and ahead of the consent gate because the
      // consent text binds to "the phone number I provide above": agreeing to
      // be called at a number that isn't a number is not a consent we should
      // bank. The web lane has no phone input at all (it is disabled out of
      // FormData entirely), so there is nothing here to check.
      //
      // This is the first place emptiness is an error. The blur handler stays
      // quiet about a blank field on purpose; a required field only becomes a
      // complaint once someone tries to submit without it.
      if (currentLane() === 'phone' && phoneEl) {
        applyPhoneFormat();
        var phoneMsg = phoneEl.value.trim()
          ? phoneProblem(phoneEl.value)
          : 'Enter your phone number';
        if (phoneMsg) {
          failField(phoneEl, phoneErrEl, phoneMsg);
          return;
        }
      }

      // Email format, EVERY path — the field beside the phone, checked in the
      // order it is read.
      //
      // Optional stays optional: `emailProblem` returns null on empty, so a
      // blank field walks straight through here and the only thing being
      // enforced is that an address someone DID type is an address. It used to
      // be validated on the consent-declined path alone, on the reasoning that a
      // false reject there costs the whole lead while elsewhere it costs a
      // nice-to-have. That undersold what the nice-to-have does: on a consented
      // submission the address is still what the acknowledgement and the offer
      // go to, and a typo'd one fails silently — a bounce nobody watches, days
      // after the seller has stopped thinking about us. Catching it costs one
      // correction while they are still on the page.
      //
      // Safe to widen because the check is deliberately permissive (see
      // `emailProblem`): it only rejects shapes that cannot receive mail at all.
      //
      // REQUIRED when the brand says so (`leadForm.email: "required"`, which
      // ReiLeadForm.astro renders as the input's `required` attribute). Then an
      // empty field stops the submit, in either lane and either step mode,
      // exactly the way an empty phone number does. The attribute is the
      // signal, so a brand that sets nothing renders none and this reads as it
      // always has. REI form only, told apart by its lane switch (the draft's
      // gate): a brand form (BrandLeadForm) marks its own fields `required`
      // and has never had them enforced here, so it must not start now.
      if (emailFieldEl) {
        var emailFormatMsg =
          laneInput && emailFieldEl.required && !emailFieldEl.value.trim()
            ? 'Enter your email address'
            : emailProblem(emailFieldEl.value);
        if (emailFormatMsg) {
          failField(
            emailFieldEl,
            document.getElementById('lf-email-err'),
            emailFormatMsg
          );
          return;
        }
      }

      // THE TERMS GATE IS GONE (2026-09-20). Box 1 became a sentence under the
      // submit button and the assent is the submit, so there is no box left to
      // be unticked and nothing here to stop. `terms_blocked` retired with it:
      // it measured which of two gates stopped a submit, and there is now one.
      //
      // `terms_agreed` was never a compliance input (no rule under
      // lib/operaitor/compliance/ reads it), and on 2026-09-21 the notice's
      // assent went too: the form no longer asks for any agreement, so it no
      // longer posts one. See PRIVACY_NOTE in src/consent.ts.

      // NEITHER CONTACT BOX CAN BLOCK A SUBMIT ANY MORE (2026-08-11, Peter's
      // call). The call box lost its last gate here; the SMS box never had one.
      // What remains required is the data fields, nothing that is a consent.
      //
      // The gate this replaced already had an email escape hatch: declining was
      // fine PROVIDED an address was left, and a phone number with neither
      // consent nor email was quarantined as unreachable. It turned out not to
      // be unreachable. The number stays human-dialable for three months on the
      // enquiry EBR regardless of this box — it is the AI VOICE that needs
      // written consent, not the act of picking up a phone — so the quarantine
      // was discarding a lead a person was allowed to work. It discarded it
      // INVISIBLY, too: quarantine answers 200 without `accepted`, so the seller
      // saw the send-failed copy, which is the same silent failure that killed
      // the web-conference lane for three days in July.
      //
      // WHAT THE BOX STILL BUYS, since it is no longer the price of submitting:
      // the AI voice, automated origination (speed-to-lead dials on submit), a
      // permission that outlives the 90-day EBR, scope beyond this one enquiry,
      // and a signed writing to hold up instead of an EBR someone has to prove.
      // Nothing here loosens any of that — `consent_agree` still posts false, so
      // every downstream gate refuses exactly as before, and
      // `Compliance.consent_covers?/2` is still the only thing that decides what
      // may actually be sent.
      //
      // WHY THIS IS THE COMPLIANT DIRECTION, not the lax one. § 64.1200(f)(9)(i)(B)
      // forbids conditioning the service on consent "directly or indirectly". A
      // gate that ends the submission unless you either tick the box or hand
      // over an address is a soft version of exactly that, and it sat one line
      // under a label promising the opposite. Now the label is simply true: a
      // seller can decline everything, submit, and still get an offer.
      //
      // DO NOT ADD A NUDGE HERE. "You'll hear back faster if you check this" is
      // the same conditioning wearing a friendlier hat, and it would be read off
      // the page by the same reviewer who unticks the box and presses submit.
      var consentEl = form.querySelector('input[name="consent_agree"]');
      if (window.gtag && consentEl && !consentEl.checked && currentLane() === 'phone') {
        // Replaces `consent_blocked` and `consent_declined_email_given`, both of
        // which measured a gate that no longer exists. This one measures the
        // DECISION rather than its consequence, which is the number actually
        // worth watching now — it is the opt-in rate, and it is the input to
        // whether the AI rail is worth what the box costs in conversion.
        // Observe-only, never a conversion: declining is not an outcome.
        window.gtag('event', 'consent_declined', { non_interaction: true });
      }
      showEmailError(null);

      // Every gate passed. Nothing is highlighted any more, so the summary that
      // pointed at a highlighted field must go with it — leaving it up over a
      // submitting form is the form contradicting itself.
      clearValidationSummary();

      var data = Object.fromEntries(new FormData(form).entries());
      // Lane, restated from the authoritative input rather than trusted from
      // FormData alone, and normalized to the two values the backend knows.
      data.contact_lane = currentLane();
      // `name` is now DERIVED. The form collects first/last separately, but
      // every downstream consumer — the lead email, the CRM row, speed-to-lead's
      // SMS templates — still reads a single `name`, so compose it here rather
      // than touching all of them. Sending both means nothing has to guess where
      // a two-word surname ends.
      //
      // The last name may be optional and left blank, or not on the form at all
      // (`leadForm.lastName`). Either way `last_name` arrives here missing or
      // empty, becomes "", and the filter drops it: `name` is the first name
      // alone, with no trailing space, and Enhanced Conversions below is handed
      // `last_name: undefined`, which gtag leaves out, never "" or the text
      // "undefined".
      data.first_name = String(data.first_name || '').trim();
      data.last_name = String(data.last_name || '').trim();
      data.name = [data.first_name, data.last_name]
        .filter(Boolean)
        .join(' ');
      data.ts = new Date().toISOString();
      data.source = location.hostname;
      data.path = location.pathname;
      data.referrer = document.referrer || null;
      data.lead_id = newLeadId();
      data.attribution = readAttribution();
      // Join keys to this visit's `lead_landings` row. Null when storage is
      // blocked, which the backend treats as "no arrival on record" rather
      // than an error.
      data.session_key = readSessionKey();
      data.visitor_key = readVisitorKey();
      // Which location-specific number this visitor was shown (see the swap
      // script in Base.astro). null = brand default number. The backend treats
      // this as a spoofable hint and re-verifies the assignment at call time.
      try {
        data.presented_number =
          JSON.parse(sessionStorage.getItem('shown_number')) ||
          window.__locNumber ||
          null;
      } catch (_) {
        data.presented_number = window.__locNumber || null;
      }

      // Contract additions (see integration-boundary plan): resolution keys,
      // versioned consent record, this lead's micro-conversion trail, intent.
      data.identity = identity;
      data.intent = 'form';
      data.contract_version = 1;
      data.events = (window.__leadEvents || []).slice(0, 50);
      // Cloudflare Turnstile token — attached ONLY when the brand carries a site
      // key AND the invisible widget minted a token. When the key is unset (or no
      // token is ready) the field is omitted entirely, preserving the current
      // no-token behavior; the edge's verifyTurnstile treats an absent token as a
      // skip while TURNSTILE_SECRET is unset, so shipping this ahead of the secret
      // is safe.
      //
      // Read further down, once the button is disabled: a second send on the
      // same page may have to wait for a fresh token (unspentTurnstileToken).
      // Timezone contract (see integration-boundary plan / Operaitor.LeadTimezones):
      // two top-level keys the webhook maps to lead_timezone + lead_timezone_source.
      //   * timezone        — the LIVE <select> IANA value (the AUTHORITATIVE
      //                       clock for the speed-to-lead TCPA gate). FormData
      //                       already captured it, but read the element directly
      //                       so a late cascade update can't be missed. Always
      //                       present — the control is never empty.
      //   * timezone_source — how the value was arrived at: "geo" | "address" |
      //                       "phone_hint" | "user" | "default". Read from the
      //                       hidden input the cascade maintains; default "default".
      // The Florida sentinel ("fl") is a display-layer value — submit a real IANA
      // clock (Eastern) and add a FL state signal so the backend's candidate_states
      // applies the 8pm cap even if the property address doesn't parse.
      //
      // Skipped entirely in the web-conference lane. The timezone control is
      // hidden and disabled there, but it still HAS a value (the brand default),
      // and these two lines read the element rather than FormData — so without
      // this guard a web-lane lead would arrive carrying a calling-window
      // preference its seller never saw, let alone chose. There is no outbound
      // call in that lane, so the honest record is no timezone at all.
      if (currentLane() === 'phone') {
        if (tzSelect && tzSelect.value) {
          data.timezone = ianaOf(tzSelect.value);
          if (tzSelect.value === 'fl') {
            data.identity = Object.assign({}, data.identity, { state: 'FL' });
          }
        }
        data.timezone_source =
          (tzSourceEl && tzSourceEl.value) || data.timezone_source || 'default';
      }

      // ── Call-time preference: no longer asked on this page ─────────────────
      // The daypart chips and the "text me before you call" box moved to the
      // optional-intake block on `my.<brand_domain>`. The keys are still SENT,
      // as explicit "nothing stated" values rather than omitted: the webhook
      // contract has them, `anytime` + `[]` are exactly what an unanswered
      // preference means, and every scalar consumer downstream keeps a valid
      // value instead of a missing key.
      //
      // Consequence worth knowing: the lead is banked (and speed-to-lead is
      // free to dial) the moment this POST lands, which is before the seller has
      // reached the intake page — so an answer given there refines the record
      // for the operator, it does not steer the FIRST dial. That is inherent to
      // asking after the offer request, not a gap in this wiring.
      data.call_time_preferences = [];
      data.call_time_preference = 'anytime';
      data.text_first = false;

      // The after-hours "call me now" box is no longer asked here (2026-09-22):
      // the call room asks it under its time question. Nothing is posted for
      // it, and the webhook reads an absent `after_hours_call_invited` as false.

      // `agreed` deliberately keeps its name AND its meaning — "may we contact
      // you" — so every outbound rail downstream (the edge gate,
      // SpeedToLead.consent_covers_call?/1) reads exactly what it always read.
      // The Terms agreement used to ride alongside it as `terms_agreed`; it
      // left on 2026-09-21 with the assent (see PRIVACY_NOTE in consent.ts).
      //
      // In the web lane `agreed` is false (no number, nothing to consent to).
      // `text_version` is still populated in BOTH lanes, so every record says
      // which wording of the contact boxes its page carried.
      // `channels` is now the UNION of the boxes actually ticked, not a
      // constant (2026-08-11). Before the split one box granted call+sms+email
      // and every submission recorded all three regardless of what was agreed
      // to, which made the array documentation rather than consent. A seller who
      // takes calls and declines texts now records ['call'], and
      // Compliance.consent_covers?/2 refuses SMS for them with nothing else in
      // the system needing to know why.
      //
      // 'email' is in NEITHER array on purpose — email is never gated on
      // consent (CAN-SPAM is opt-out), and naming it is what cost the toll-free
      // verification. See the 2026-08-11 entry in src/consent.ts.
      var smsConsentEl = form.querySelector('input[name="sms_consent_agree"]');
      var grantedChannels = [];
      if (consentEl && consentEl.checked) {
        grantedChannels = grantedChannels.concat(callConsentChannels);
      }
      if (smsConsentEl && smsConsentEl.checked) {
        grantedChannels = grantedChannels.concat(smsConsentChannels);
      }

      data.consent = {
        agreed: !!(consentEl && consentEl.checked),
        // The SMS opt-in rides ALONGSIDE `agreed` as its own flag, never folded
        // into it: merging them in the record rebuilds the bundling the
        // separate boxes exist to undo. A
        // reviewer asking "was SMS consent given separately" has to be able to
        // read the answer off one field.
        sms_agreed: !!(smsConsentEl && smsConsentEl.checked),
        // NO `terms_agreed` / `terms_text` since 2026-09-21. The form shows no
        // Terms assent any more, and a record claiming one would say the
        // seller did something they never did. See PRIVACY_NOTE in consent.ts.
        text_version: data.consent_version || null,
        ts: new Date().toISOString(),
        channels: grantedChannels,
        // WHAT THEY READ, stored alongside what they ticked — the same promise
        // after_hours.disclosure_text and timezone.attestation_text already
        // keep, now kept for the box that matters most.
        //
        // Until this landed, a form consent recorded only `text_version`, and
        // recovering the sentence meant re-rendering the server's copy of that
        // version — which drifts the moment the wording is retired or the brand
        // is renamed. E-SIGN asks that the record be capable of accurate
        // REPRODUCTION; a re-render is a reconstruction.
        //
        // Only for a box actually ticked. An unchecked box granted nothing, and
        // recording its wording would put a sentence in the consent record that
        // the seller declined.
        text: consentEl && consentEl.checked ? consentLabelText(consentEl) : null,
        sms_text:
          smsConsentEl && smsConsentEl.checked ? consentLabelText(smsConsentEl) : null,
      };
      // raw checkbox/version fields folded into the structured `consent` object.
      // `terms_agree` left this list on 2026-09-20 with the checkbox that
      // produced it — a form with no such control cannot post one.
      delete data.consent_agree;
      delete data.consent_version;

      var btn = form.querySelector('button[type="submit"]');
      var btnText = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Sending…';
      }

      var cfTurnstileToken = await unspentTurnstileToken();
      if (cfTurnstileToken) data.cf_turnstile_token = cfTurnstileToken;

      // Only an explicit server ack (result.accepted === true) counts — NOT a
      // bare res.ok. A quarantined submission returns HTTP 200 without
      // `accepted`, so gating on ok would silently drop a false-positive-
      // quarantined human AND report a phantom conversion. On any not-accepted
      // outcome (network error, non-2xx, or quarantine) the lead lives on in the
      // localStorage draft, but we must NOT show success and must NOT count any
      // conversion — re-enable the button so the seller can retry.
      var result = await submitLead(data);
      // Spent whatever the edge made of it, accepted or not.
      retireTurnstileToken();
      if (!result || result.accepted !== true) {
        if (btn) {
          btn.disabled = false;
          btn.textContent = btnText || 'Submit';
        }
        var undeliverable = !!(result && result.undeliverable);
        showSubmitError(undeliverable);
        // Diagnostic only (never a conversion) so failed submits are measurable.
        // `reason` separates the two populations in GA4: an undeliverable edge is
        // a config alarm (every submit on that host is lost), a plain error is
        // ordinary network noise. Without it they'd average into one flat rate.
        if (window.gtag) {
          window.gtag('event', 'lead_submit_failed', {
            reason: undeliverable ? 'undeliverable' : 'error',
            non_interaction: true,
            status: (result && result.status) || 0,
          });
        }
        return;
      }
      clearSubmitError();

      // Is this the same seller sending the same request a second time, having
      // pressed Back from the call room to fix something? Read BEFORE stamping
      // this submit, because the answer decides whether the primary conversion
      // fires again at the bottom of this handler.
      //
      // The lead itself deliberately still goes with a FRESH lead_id (see
      // newLeadId above): `lead_submissions` is unique on lead_id and the
      // webhook answers a repeat with `duplicate` WITHOUT updating the row, so
      // reusing the id would ack the correction and then quietly discard it —
      // and the correction is the entire reason they came back.
      var resubmit = draftSubmitted;
      draftSubmitted = true;
      draftSave();
      if (!KEEP_DRAFT_AFTER_SUBMIT) {
        try { sessionStorage.removeItem(DRAFT_KEY); } catch (_) {}
      }

      // Speed-to-lead: the call room is the seller's next step. Read the base
      // off the FORM, not off #talk-now-btn — that button was the REI form's
      // third step and is gone, and hanging the handoff URL on a control we
      // were free to delete is how deleting it would have silently disabled the
      // handoff. The button fallback is still live for BrandLeadForm, which
      // keeps its success card.
      var talkBtn = document.getElementById('talk-now-btn');
      var talkBase =
        form.dataset.talkBase || (talkBtn && talkBtn.dataset.talkBase) || '';
      var brandId = (data.identity && data.identity.brand) || '';
      lastLeadId = data.lead_id || '';

      // ── Hand off to my.<brand_domain> ──────────────────────────────────────
      // The seller continues on the call-room host: "request" (the only button
      // the REI form ships today) lands on the optional-intake block, "call"
      // would go straight into the room. The lead is already banked either way
      // — this navigation is the next step, not the submission.
      //
      // Gated on the lane switch actually being present, i.e. on this being the
      // two-lane REI form. A brand-driven form (BrandLeadForm, from
      // `brand.leadFields`) shares this whole script but was never part of this
      // change, and it has no `my.<brand_domain>` follow-up to land on — so it
      // keeps the in-page success card with its Talk-now / Pick-a-time pair.
      //
      // Also falls through to that card when there is no call room to go to at
      // all (PUBLIC_TALK_BASE unset, or no brand id), which is exactly what
      // every brand saw before this existed.
      //
      // The success card is shown ONLY on that fallback. On the handoff path
      // there is no interstitial at all: step 2 stays on screen with its button
      // reading "Sending…" until the room replaces it. Flashing "Got it" for
      // 150ms on the way out is a third page the seller cannot use and cannot
      // read, and it is the page this change exists to remove.
      if (!(laneInput && talkBase && brandId)) {
        form.hidden = true;
        success.hidden = false;
        success.focus && success.focus();
      }

      if (laneInput && talkBase && brandId) {
        // Remember WHICH room, before leaving for it. This is the one line that
        // makes a later visit resumable: `/start` reuses a room only when the
        // same `lead` comes back to it, and every submit mints a fresh id — so
        // without a pointer kept here, a seller who returns tomorrow is a
        // stranger with a second room. See the resume block above for what is
        // stored (a lead id, never the answers) and why.
        roomPointerSave(data.lead_id);
        var handoff =
          talkBase.replace(/\/+$/, '') +
          '/start?b=' + encodeURIComponent(brandId) +
          '&lead=' + encodeURIComponent(data.lead_id || '') +
          roomAttributionQuery(data.attribution) +
          (pendingAction === 'call' ? '' : '&mode=intake');
        // No conversion fires here. `call_requested` belongs to the call room,
        // which records it server-side on :connect — a seller who lands in the
        // room and never connects has not requested a call, and this handler
        // cannot know the difference. It also keeps the rail boundary intact:
        // everything before triage reports by pixel through ONE Website
        // conversion action, and the room already owns this event.
        //
        // The small delay stands on its own: the keepalive POST from the submit
        // above, and the pixel for lead_form_submit further down, both need a
        // tick to leave the tab. A hard navigate in the same tick cancels them
        // on some browsers.
        setTimeout(function () {
          window.location.assign(handoff);
        }, 150);
      }
      if (talkBtn && talkBase && brandId) {
        talkBtn.href =
          talkBase.replace(/\/+$/, '') +
          '/start?b=' + encodeURIComponent(brandId) +
          '&lead=' + encodeURIComponent(data.lead_id || '');
        talkBtn.hidden = false;
        // The button no longer stands alone — it sits in a block with its own
        // heading and description, and that whole block stays hidden until the
        // href is real. Otherwise a brand with no call room would render a
        // heading and a paragraph about a button that never appears.
        revealSuccessOption(talkBtn);
        if (!talkBtn.dataset.lfWired) {
          talkBtn.dataset.lfWired = '1';
          talkBtn.addEventListener('click', function () {
            fireRoomDoor(lastLeadId);
          });
        }
      }

      // Secondary path: schedule a callback for later — opens the room straight on
      // the slot picker (mode=schedule).
      var scheduleBtn = document.getElementById('schedule-btn');
      var scheduleBase = (scheduleBtn && scheduleBtn.dataset.talkBase) || '';
      if (scheduleBtn && scheduleBase && brandId) {
        scheduleBtn.href =
          scheduleBase.replace(/\/+$/, '') +
          '/start?b=' + encodeURIComponent(brandId) +
          '&lead=' + encodeURIComponent(data.lead_id || '') +
          '&mode=schedule';
        scheduleBtn.hidden = false;
        revealSuccessOption(scheduleBtn);
        if (!scheduleBtn.dataset.lfWired) {
          scheduleBtn.dataset.lfWired = '1';
          scheduleBtn.addEventListener('click', function () {
            fireRoomDoor(lastLeadId);
          });
        }
      }

      // Normalize PII for Enhanced Conversions for Leads. gtag SHA-256s
      // these client-side before sending to GA4/Google Ads; we just need to
      // pass canonical forms (lowercase email, E.164 phone, trimmed names).
      var emailNorm = String(data.email || '').trim().toLowerCase();
      var phoneNorm = normalizePhone(data.phone);
      // Straight from the form now. This used to split `name` on whitespace and
      // call everything after the first token the surname, which quietly
      // mis-hashed every "Mary Anne" and every "van der Berg" — and a wrong hash
      // is a silent match failure, not an error.
      var firstName = data.first_name || '';
      var lastName = data.last_name || '';

      if (window.gtag) {
        // Set user_data BEFORE the conversion event. gtag will pick this up
        // when sending the lead_form_submit event and hash it for ECL.
        // Requires "Enhanced Conversions for Leads" to be enabled on the
        // imported conversion action in Google Ads. ~30% match-rate uplift
        // vs anonymous conversions.
        window.gtag('set', 'user_data', {
          email: emailNorm || undefined,
          phone_number: phoneNorm || undefined,
          address: {
            first_name: firstName || undefined,
            last_name: lastName || undefined,
          },
        });
      }

      // Top of the micro-conversion ladder. $600 = $75k typical deal profit
      // × ~1% form→close × 0.75 safety. See ladder doc in
      // src/layouts/Base.astro → setupMicroConversions().
      //
      // transaction_id is the conversion's stable join key. Google Ads's
      // Conversion Adjustment Upload API matches against it to restate the
      // value once we know the real closed-deal margin.
      //
      // Route through __fireConversion (defined in Base.astro's tracking
      // loader): this fires the GA4 event AND, once googleAdsId + the
      // lead_form_submit label are set, the Ads conversion (send_to). The
      // helper dedupes the Ads ping so a double-submit can't double-count
      // the primary conversion.
      //
      // Guarded on the helper itself, matching every other __fireConversion
      // call site in this file. This used to sit inside the `window.gtag`
      // check above and fall back to `window.gtag.bind(null, 'event')` — a
      // branch that could never be taken, since bootGtagBase() defines gtag
      // and __fireConversion together in one synchronous call, so no script
      // can ever observe one without the other.
      //
      // Suppressed on a re-submit. One seller correcting one request is ONE
      // lead, and it has already been counted — but the dedupe inside
      // __fireConversion is per-document, so it cannot see across a Back that
      // re-parsed the page, and the new lead_id means Google's own order-id
      // dedupe won't catch it either. This is the primary conversion the whole
      // pre-triage rail bids on; letting it double-count would teach Smart
      // Bidding that a hesitant seller is worth twice a confident one.
      if (window.__fireConversion && !resubmit) {
        window.__fireConversion('lead_form_submit', {
          // value omitted — inherits leadValueMap['lead_form_submit'] ($600) from
          // conversion-config.json via Base.astro's __fireConversion default.
          currency: 'USD',
          transaction_id: data.lead_id,
          source: data.source,
          path: data.path,
          // Attribution included as event params so they show up in GA4
          // reports without needing the server-side webhook. Limited to the
          // most useful fields to stay under GA4's custom-param cap.
          campaign_gclid:
            (data.attribution.first && data.attribution.first.gclid) ||
            (data.attribution.latest && data.attribution.latest.gclid) ||
            undefined,
          campaign_source:
            (data.attribution.first && data.attribution.first.utm_source) ||
            undefined,
          campaign_medium:
            (data.attribution.first && data.attribution.first.utm_medium) ||
            undefined,
          campaign_name:
            (data.attribution.first && data.attribution.first.utm_campaign) ||
            undefined,
        });
      }

      // ── Qualified-lead OR-gate (LP8) ──────────────────────────────────────
      // A separate, instrument-only conversion that fires ONLY when the seller
      // trips a qualification signal — so Smart Bidding (when it's later pointed
      // at this event) optimizes toward assignable, motivated sellers instead of
      // raw form-fill volume. It is NOT a bid target yet; this wiring just makes
      // the signal exist and fire correctly.
      //
      // WHAT IT CAN SEE: the ad-group category, and nothing else. It used to also
      // keyword-scan the optional "What's your situation?" <select name="reason">
      // for motivation/condition phrases, but that field no longer exists on the
      // form (it moved to the intake block on `my.<brand_domain>`, as free text).
      // `data.reason` was therefore always undefined and both keyword branches
      // were permanently false, so they are deleted rather than left standing as
      // documentation of behavior that cannot happen.
      //
      // WHAT IT CANNOT SEE: any lead whose category doesn't qualify. The generic
      // WH/TL bucket and the untracked homepage have no qualifying category and
      // no other signal left, so they have no path to qualify at all — this gate
      // under-reports by construction and always will.
      //
      // That is accepted rather than patched here, because the real qualification
      // signal is planned to arrive from post-triage operator assessment (quality
      // decided AFTER triage — docs/wip/ads-offline-transport-data-manager.md),
      // where a human has actually spoken to the seller. Guessing harder at submit
      // time would only make a pre-conversation proxy louder, not truer.
      var cat = String(
        (data.identity && data.identity.category) || ''
      ).toUpperCase();
      // Categories that auto-qualify per the plan: foreclosure, probate and
      // divorce carry inherent urgency; as-is/vacant carries inherent condition.
      var URGENCY_CATS = { FC: 1, PR: 1, DV: 1 };
      var CONDITION_CATS = { VS: 1 };

      // OR gate — either signal qualifies. A missing/unknown category (LP7) is
      // safe by construction: both lookups simply miss, so the gate stays silent
      // instead of throwing or guessing.
      var isQualified = !!URGENCY_CATS[cat] || !!CONDITION_CATS[cat];

      if (isQualified) {
        // Route through __fireConversion so it inherits the consent/deferred-
        // tracking gate AND the send_to conversion-label path (once the
        // qualified_lead label is set in the brand JSON). The helper dedupes
        // the Ads ping per event name, so this fires at most once per submit;
        // the submit button is disabled after the first submit, so a
        // double-submit can't re-fire it either. Falls back to a bare gtag
        // event if the helper somehow isn't present.
        // observe-only signal: lead_form_submit already carries the $600 lead
        // value, so qualified_lead is configured at value 0 to avoid double-
        // counting the same submission in value-based reporting/bidding. value
        // omitted here — inherits leadValueMap['qualified_lead'] (0) from config.
        (window.__fireConversion || (window.gtag && window.gtag.bind(null, 'event')) || function () {})(
          'qualified_lead',
          {
            currency: 'USD',
            transaction_id: data.lead_id,
          }
        );
      }

      if (window.fbq) {
        window.fbq('track', 'Lead');
      }
    });
  })();
})();
} catch (e) {
  setTimeout(function () { throw e; });
}